{
  "adgroup": {
    "alwaysFirst": "Sempre prima",
    "archiveWarning": "Stai per archiviare permanentemente questo gruppo di annunci. Nessun dato andrà perso ma non potrai riattivarlo. Vuoi archiviare permanentemente questo gruppo di annunci?",
    "created": "Nuovo gruppo di annunci creato!",
    "updated": "Il tuo gruppo di annunci è stato aggiornato!",
    "goToAdgroup": "Vai a {{adgroupName}}",
    "sectionTitle": "Riepilogo del gruppo di annunci",
    "appendClickId": "Aggiungi ID clic",
    "type": "Tipo",
    "format": "Formato",
    "redirectUrl": "URL di reindirizzamento",
    "redirectUrlDoubleClickWarning": "È impossibile inoltrare l'ID clic su un collegamento DoubleClick senza aggiungere il collegamento di destinazione alla fine.",
    "rulesExceptionsLabel": "Esclusione delle regole geografiche",
    "rulesExceptions": "Puoi bloccare i paesi con cui non vuoi trattare. Il traffico proveniente da questi paesi verrà reindirizzato al seguente URL di reindirizzamento anziché a quello predefinito.",
    "redirectUrlHelper": "Deve includere parametri di tracciamento. Se nella creatività non è specificato alcun URL, verrà utilizzato questo URL predefinito.",
    "channels": "Canali",
    "redirectUrlUtmGenerator": {
      "title": "Assistente URL di reindirizzamento",
      "generateUrl": "Genera URL",
      "generatedUrl": "URL generato",
      "utmDetectedMessage": "Chiavi UTM esistenti rilevate nell'URL corrente: {{keys}}. La generazione aggiornerà queste chiavi.",
      "utmParameters": "Parametri UTM",
      "valueType": "Tipo",
      "customValue": "Personalizzato",
      "dynamicValue": "Dinamico",
      "parameterValue": "Valore",
      "noUtmFound": "Nessun parametro UTM trovato nell'URL di reindirizzamento.",
      "initializeDefaultUtm": "Aggiungi UTM predefinito",
      "resetDefaultUtm": "Ripristina UTM predefinito",
      "customParameters": "Parametri personalizzati",
      "addParameter": "Aggiungi parametro",
      "noCustomParameters": "Nessun parametro personalizzato.",
      "documentation": "Documentazione",
      "defaultUtmValues": "Valori UTM predefiniti",
      "applyToRedirectUrl": "Applica all'URL di reindirizzamento",
      "serverTokens": {
        "title": "Token sostitutivi del server",
        "groups": {
          "advertiserInfo": "Informazioni sull'inserzionista",
          "publisherInfo": "Informazioni sull'editore"
        },
        "clickIdAutoNote": "Nota: {clickId} viene aggiunto automaticamente quando manca.",
        "descriptions": {
          "campaignId": "Identificatore della campagna",
          "campaignName": "Nome della campagna",
          "adGroupId": "Identificatore del gruppo di annunci",
          "adGroupName": "Nome del gruppo di annunci",
          "adcopyInfos": "Informazioni creative",
          "adCopyId": "Identificatore della creatività",
          "adCopyName": "Nome della creatività",
          "clickId": "Identificatore di clic univoco (aggiunto automaticamente se mancante)",
          "publisherInfos": "Informazioni sull'editore",
          "pubName": "Nome dell'editore",
          "siteName": "Nome del sito web",
          "posName": "Nome della posizione"
        }
      }
    },
    "channelsHelper": "I canali raggruppano le posizioni degli annunci per tipo di canale. 'Email' corrisponde agli annunci nativi nelle newsletter/e-mail, mentre 'Web' corrisponde agli annunci nativi sui siti web.",
    "network": "Rete",
    "notFound": "Gruppo di annunci non trovato",
    "create": "Crea nuovo gruppo di annunci",
    "edit": {
      "sectionTitle": "Modifica gruppo di annunci"
    },
    "details": {
      "title": "Dettagli",
      "archived": "Archiviato",
      "budgetCapping": "Limite",
      "companyName": "Azienda",
      "costType": "Tipo",
      "costValueWithCurrency": "Costo",
      "dailyBudgetWithCurrency": "Budget giornaliero",
      "marketCode": "Mercato",
      "network": "Rete",
      "resellerName": "Rivenditore",
      "impressionPixels": "Pixel di impressione",
      "clickPixels": "Pixel di clic",
      "commission": "Commissione",
      "campaignId": "Seleziona la campagna del nuovo gruppo di annunci",
      "type": "Tipo"
    },
    "budgetAndDates": {
      "title": "Budget e date",
      "dailyBudgetTypeHelper": "- Fisso: il budget giornaliero è fisso.<br />- Aperto: il budget giornaliero non ha limiti.<br />- Automatico: il budget giornaliero viene calcolato automaticamente in base al limite del budget e alla data di fine.",
      "dailyBudgetHelper": "Questo è il budget massimo giornaliero del gruppo di annunci. Può essere regolato in seguito",
      "budgetCapping": "Plafond di budget",
      "budgetCappingHelper": "Questa configurazione facoltativa limiterà il budget mensile o totale del gruppo di annunci. Il gruppo di annunci verrà interrotto una volta raggiunto il budget.",
      "budgetCappingPeriod": "Periodo",
      "budgetTypeLabel": "Tipo di budget giornaliero",
      "budgetType": {
        "Fixed": "Fisso",
        "Open": "Aperto",
        "Auto": "Automatico"
      },
      "dateHelper": "Questa configurazione facoltativa ti consente di impostare date personalizzate per il tuo gruppo di annunci. Le date sono incluse. Il gruppo di annunci inizierà alle 00:01 e terminerà alle 23:59.",
      "endDateValidation": "La data di fine non può essere precedente alla data di inizio",
      "budgetCappingType": "Tipo di limitazione del budget",
      "budgetCappingTypeHelper": "- Mensile: il budget si azzera all'inizio di ogni mese.<br />- Nessun limite: il budget è illimitato.<br />- Complessivamente: il budget è un limite sull'intera durata del gruppo di annunci.<br />- Periodo: il budget si applica dalla data di inizio fino alla fine del gruppo di annunci.",
      "overallCalculator": {
        "title": "Calcolatore budget overall",
        "open": "Modifica budget overall",
        "currentBudget": "Budget attuale",
        "leftToSpend": "Residuo da spendere",
        "amount": "Importo da aggiungere o rimuovere",
        "amountHelper": "Inserisci un importo positivo per aumentare il budget o un importo negativo per diminuirlo.",
        "preview": "Anteprima",
        "newBudget": "Nuovo budget",
        "newLeftToSpend": "Nuovo residuo da spendere",
        "apply": "Applica al budget",
        "outOfBounds": "Il nuovo budget deve essere compreso tra {{min}} e {{max}}."
      },
      "budgetPlans": {
        "button": "Pianifica modifiche",
        "title": "Modifiche di budget pianificate",
        "add": "Aggiungi una modifica pianificata",
        "edit": "Modifica la modifica pianificata",
        "editTitle": "Modifica la modifica pianificata",
        "plannedDate": "Data di esecuzione",
        "dateHelper": "La modifica viene applicata dal processo giornaliero a partire da questa data. È possibile pianificare solo date a partire da domani.",
        "unchanged": "Nessuna modifica",
        "empty": "Nessuna modifica di budget pianificata",
        "delete": "Elimina modifica pianificata",
        "dateMustBeFuture": "Scegli una data a partire da domani",
        "duplicateDate": "Esiste già un piano per questa data",
        "inactiveWarning": "Questo gruppo di annunci è inattivo. Non verrà riattivato automaticamente.",
        "archivedWarning": "Questo gruppo di annunci è archiviato. Non verrà riattivato automaticamente.",
        "atLeastOneChange": "Imposta almeno un campo costo, budget o periodo da modificare",
        "autoOpenForbidden": "Il budget giornaliero automatico non può essere combinato con un capping aperto",
        "previewCost": "Costo",
        "previewPeriod": "Periodo"
      }
    },
    "status": {
      "nobudgetleft": "Nessun budget rimasto",
      "startsoon": "Inizierà a breve",
      "ended": "Terminato",
      "archived": "Archiviato",
      "activationWarning": {
        "nobudgetleft": "Verrà attivato automaticamente dopo aver aumentato il budget",
        "startsoon": "Verrà attivato automaticamente alla data di inizio",
        "ended": "Verrà attivato automaticamente dopo la modifica o la cancellazione della data di fine",
        "archived": "Impossibile attivare un gruppo di annunci archiviato"
      }
    },
    "spentBudget": {
      "daySpent": "Spesa giornaliera",
      "monthSpent": "Spesa mensile",
      "overallSpent": "Spesa totale",
      "periodSpent": "Spesa nel periodo",
      "leftAmount": "({{left}} rimanenti)",
      "history": {
        "open": "Visualizza cronologia budget",
        "title": "Cronologia budget",
        "seriesToggleLabel": "Serie del grafico",
        "costChartTitle": "Valore costo per giorno ({{costType}})",
        "noCostChartData": "Nessuna modifica del costo in questo periodo.",
        "noChanges": "Nessuna modifica alle date in questo periodo.",
        "chartLegendCost": "{{label}}: {{value}} ({{costType}})",
        "chartLegendValue": "{{label}}: {{value}}",
        "chartLegendCapping": "{{label}}: {{value}} ({{type}})",
        "chartLegendTypeOnly": "{{label}}: {{type}}",
        "changedBy": "Modificato da {{name}}"
      },
      "messageStatus": {
        "endDatePassed": "| È stato interrotto il {{endDate}}",
        "overSpent": "| Nessun budget rimasto da {{stoppedDate}}",
        "willStart": "| Inizierà il {{startDate}}",
        "willStopAtMonthly": "| Si fermerà il {{endDate}} e resteranno {{leftMonthBudget}} questo mese",
        "willStopAtPeriod": "| Si fermerà il {{endDate}} e resteranno {{leftPeriodBudget}}",
        "willStopAtOverall": "| Si fermerà il {{endDate}} e resteranno {{leftOverallBudget}}",
        "willStop": "| Si fermerà il {{endDate}}",
        "budgetMonthly": "| {{leftMonthBudget}} rimanenti questo mese",
        "budgetPeriod": "| {{leftPeriodBudget}} rimasto",
        "budgetOverall": "| {{leftOverallBudget}} rimasto"
      },
      "warning": {
        "endDateSoon": "Questo gruppo di annunci verrà interrotto tra {{daysThreshold}} giorni o meno."
      }
    },
    "userCapping": {
      "title": "Limite utente",
      "event": "evento",
      "period": "Periodo",
      "value": "valore",
      "noCapping": "Nessun limite",
      "helperText": "Impressioni = quante volte le persone vedono il tuo annuncio. Clic = quante volte le persone fanno clic sul tuo annuncio."
    },
    "userTargeting": {
      "autoSegments": {
        "noSegment": "Nessun segmento automatico attivo",
        "title": "Segmenti automatici",
        "add": "Aggiungi un segmento automatico",
        "type": "Tipo",
        "dimension": "Dimensione",
        "delete": "Elimina questo segmento automatico",
        "id": "Nome",
        "duration": "Durata (giorno)",
        "isExcluded": "Incluso/Escluso",
        "dimensions": {
          "Advertiser": "Inserzionista",
          "Publisher": "Editore",
          "AdGroup": "Gruppo di annunci",
          "Website": "Sito web",
          "Campaign": "Campagna",
          "AdGroupIab": "Gruppo di annunci Iab",
          "PositionIab": "Posizione Iab"
        }
      },
      "tags": {
        "noTags": "Nessun tag attivo",
        "title": "Tag",
        "add": "Aggiungi un'etichetta",
        "delete": "Elimina questo tag",
        "origin": "Origine",
        "profileCount": "Numero di profili",
        "description": "Descrizione",
        "isExcluded": "Incluso/Escluso"
      },
      "title": "Targeting per utente",
      "targetingGenderLabel": "Genere target",
      "targetingAgeLabel": "Età target",
      "gender": {
        "Male": "Maschio",
        "Female": "Femmina"
      },
      "targeting": "Targeting",
      "customAudienceLabel": "Pubblico personalizzato",
      "customAudience": {
        "cdate": "Data di creazione",
        "nbProfiles": "Numero di profili"
      },
      "noActiveSegments": "Non hai segmenti attivi. ",
      "goToCampgaignSegments": "Vai ai segmenti della campagna."
    },
    "deviceTypes": {
      "title": "Tipi di dispositivi",
      "helperText": "Consente di rivolgersi a utenti specifici che *navigano* da dispositivi e sistemi operativi specifici",
      "deviceTargetingLabel": "Targeting per dispositivo",
      "osTargetingLabel": "Targeting del sistema operativo",
      "deviceType": {
        "Desktop": "Desktop",
        "Mobile": "Mobile",
        "Tablet": "Tablet"
      },
      "osType": {
        "Android": "Android",
        "Ios": "iOS",
        "Macos": "macOS",
        "Windows": "Windows"
      }
    },
    "geoTargeting": {
      "title": "Targeting geografico",
      "helperText": "Per impostazione predefinita, gli annunci vengono pubblicati nell'inventario del mercato del gruppo di annunci. Anche gli utenti che navigano da altri paesi potrebbero essere presi di mira. ",
      "rule": "Regola",
      "locationType": "Tipo di posizione",
      "locationTypeHelper": "È possibile selezionare solo un tipo. Se modifichi la selezione verrà cancellata.",
      "cities": "Città",
      "departements": "Dipartimenti",
      "regions": "Regioni",
      "countries": "Paesi",
      "location": "Posizione/i",
      "viewAllLocations_one": "Visualizza tutte le posizioni ({{count}})",
      "viewAllLocations_other": "Visualizza tutte le posizioni ({{count}})",
      "manageLocationsTitle": "Gestisci posizioni ({{count}})",
      "viewLocationsTitle": "Tutte le posizioni ({{count}})",
      "radiusDialogTitle": "Aggiorna il raggio di {{city}}",
      "marketCountry": "I tuoi annunci verranno visualizzati sul mercato {{countryCode}}",
      "acceptedCountries": "Paesi accettati",
      "allCountries": "Tutti",
      "importCSV": "Importa tramite CSV",
      "targetingAddresses": {
        "clearPrevious": "Rimuovi il GeoTargeting precedente",
        "numberAddressesFound": "Indirizzi {{addressesFound}} trovati",
        "radius": "Raggio",
        "csvUploadInfoMessage": "Carica un file CSV contenente un elenco di nomi di città e/o codici postali. Ogni voce deve essere posizionata su una nuova riga. Puoi avere un mix di nomi di città e codici postali.",
        "success": "L'elenco delle città e dei codici postali è stato importato",
        "unrecognizedCitiesMessage": "Impossibile trovare alcune città nel file CSV caricato. Controlla l'elenco delle città non riconosciute di seguito, correggi eventuali errori o errori di battitura e prova a caricare nuovamente il file:"
      },
      "viewAllLocations_many": "Visualizza tutte le posizioni ({{count}})",
      "panel": {
        "addToTargeting": "Aggiungi al targeting",
        "alreadyTargeted_one": "{{count}} già selezionata, elencata sotto",
        "alreadyTargeted_other": "{{count}} già selezionate, elencate sotto",
        "byType": "per",
        "clearAll": "Cancella tutto",
        "clearAllConfirm_one": "Rimuovere la posizione dal targeting?",
        "clearAllConfirm_other": "Rimuovere tutte le {{count}} posizioni dal targeting?",
        "clearSearch": "Cancella la ricerca",
        "columnCity": "Città",
        "columnCodeRegion": "Codice · Regione",
        "columnCountry": "Paese",
        "columnDepartement": "Dipartimento",
        "columnRadius": "Raggio",
        "columnRegion": "Regione",
        "decreaseRadius": "Riduci il raggio di {{name}}",
        "deselectAll": "Deseleziona tutto",
        "empty": "Nessuna posizione selezionata per ora.",
        "enterToAdd": "Invio per aggiungere · Esc per chiudere",
        "suggestionTargeted": "Già targetizzato",
        "excluded": "escluse",
        "increaseRadius": "Aumenta il raggio di {{name}}",
        "matchCount": "{{shown}} di {{total}}",
        "noMatch": "Nessuna posizione corrisponde a «{{query}}»",
        "noNewPlace": "Nessuna nuova posizione corrisponde a «{{query}}»",
        "noneTargeted": "Nessuna posizione selezionata corrisponde",
        "previewTitle": "Nuovo elenco delle posizioni (anteprima)",
        "radiusFor_one": "Raggio per {{count}} posizione selezionata",
        "radiusFor_other": "Raggio per {{count}} posizioni selezionate",
        "radiusValue": "{{radius}} km",
        "range": "{{from}}–{{to}} di {{count}}",
        "rangeMatching": "{{from}}–{{to}} di {{count}} corrispondenti",
        "regionCount_one": "da {{count}} regione",
        "regionCount_other": "da {{count}} regioni",
        "removeLocation": "Rimuovi {{name}}",
        "removeSelected": "Rimuovi",
        "removedMany_one": "{{count}} posizione rimossa",
        "removedMany_other": "{{count}} posizioni rimosse",
        "removedOne": "Rimosso: {{name}}",
        "rowsPerPage": "Righe",
        "searchOnly_one": "Cerca tra {{count}} posizione",
        "searchOnly_other": "Cerca tra {{count}} posizioni",
        "searchOrAdd": "Cerca le tue posizioni o aggiungine una",
        "searchOrExclude": "Cerca le posizioni escluse o escludine una nuova",
        "selectAllMatching_one": "Seleziona tutte ({{count}})",
        "selectAllMatching_other": "Seleziona tutte ({{count}})",
        "selectLocation": "Seleziona {{name}}",
        "selectPage": "Seleziona questa pagina",
        "selected_one": "{{count}} selezionata",
        "selected_other": "{{count}} selezionate",
        "setRadius": "Imposta raggio",
        "targeted": "selezionate",
        "undo": "Annulla",
        "view": "Visualizzazione",
        "viewChips": "Etichette",
        "viewTable": "Tabella",
        "removedMany_many": "{{count}} posizioni rimosse",
        "clearAllConfirm_many": "Rimuovere tutte le {{count}} posizioni dal targeting?",
        "searchOnly_many": "Cerca tra {{count}} posizioni",
        "alreadyTargeted_many": "{{count}} già selezionate, elencate sotto",
        "selected_many": "{{count}} selezionate",
        "selectAllMatching_many": "Seleziona tutte ({{count}})",
        "radiusFor_many": "Raggio per {{count}} posizioni selezionate",
        "regionCount_many": "da {{count}} regioni"
      },
      "ruleHintInclude": "Gli annunci vengono mostrati solo in queste posizioni.",
      "ruleHintExclude": "Gli annunci vengono mostrati ovunque sul mercato {{countryCode}}, tranne in queste posizioni."
    },
    "timeOfTheDay": {
      "title": "Ora del giorno",
      "helperText": "Consente di pubblicare annunci in giorni della settimana e intervalli di tempo selezionati.",
      "daysOfTheWeekLabel": "Giorni della settimana",
      "hoursOfTheDayLabel": "Ore del giorno",
      "days": {
        "Monday": "Lunedì",
        "Tuesday": "Martedì",
        "Wednesday": "Mercoledì",
        "Thursday": "Giovedì",
        "Friday": "Venerdì",
        "Saturday": "Sabato",
        "Sunday": "Domenica"
      }
    },
    "tabs": {
      "directory": "restrizione della trasmissione",
      "bidAdjustments": "aggiustamenti delle offerte",
      "adPreview": "anteprima",
      "blacklist": "Lista nera",
      "dashboard": "dashboard",
      "settings": "impostazioni"
    },
    "assistant": {
      "title": "Assistente gruppo di annunci",
      "button": "Assistente",
      "showMeLater": "Mostramelo più tardi",
      "okForToday": "Ok per oggi",
      "recommendationsTitle": "Consigli sui gruppi di annunci",
      "noRecommendations": "Nessuna raccomandazione disponibile per ora.",
      "noDataYet": "nessun dato ancora",
      "hideRule": "Nascondi regola",
      "showRule": "Mostra regola",
      "disableRule": "Disabilita regola",
      "enableRule": "Abilita regola",
      "hidden": "Nascosto",
      "showHiddenRules": "Mostra regole nascoste",
      "hideHiddenRules": "Nascondi regole nascoste",
      "ruleHidden": "Regola nascosta correttamente",
      "ruleHideFailed": "Impossibile nascondere la regola",
      "ruleShown": "Regola mostrata correttamente",
      "ruleShowFailed": "Impossibile mostrare la regola",
      "ruleDisabled": "Regola disabilitata correttamente",
      "ruleDisableFailed": "Impossibile disabilitare la regola",
      "ruleEnabled": "Regola abilitata correttamente",
      "ruleEnableFailed": "Impossibile abilitare la regola",
      "decisions": {
        "abTest": "Test A/B",
        "continue": "Continua",
        "stop": "Interrompi"
      },
      "recommendations": {
        "abTest": "Esegui questa creatività in modalità test A/B.",
        "continue": "Mantieni attiva questa creatività.",
        "stop": "Metti in pausa questa creatività."
      },
      "recommendationCodes": {
        "AdCopyMaxLifetimeExceeded": "Una o più creatività hanno raggiunto la durata massima",
        "AdGroupNotEnoughAdCopiesForBudget": "Il gruppo di annunci non ha abbastanza creatività per il budget",
        "AdGroupTooManyAdCopiesForBudget": "Il gruppo di annunci contiene troppe creatività per il budget",
        "AdGroupAdCopyReadyForNewAbTest": "Il gruppo di annunci ha una creatività pronta per un nuovo test A/B",
        "AdGroupImbalancedAbTestImpressions": "Il gruppo di annunci presenta impressioni del test A/B sbilanciate",
        "AdGroupIncreaseDailyBudgetForBudgetCapping": "Il gruppo di annunci ha un limite di budget giornaliero troppo basso. Aumenta il budget giornaliero o utilizza il budget giornaliero automatico"
      },
      "table": {
        "adCopy": "Creativo",
        "decision": "Decisione",
        "recommendation": "Raccomandazione",
        "actions": "Azioni",
        "startedAt": "Iniziato alle",
        "hiddenColumnsWarning": "Le seguenti colonne sono nascoste perché non contengono dati: {{columns}}",
        "lr": "LR",
        "cpl": "CPL",
        "or": "OR",
        "cpo": "CPO",
        "roi": "ROI"
      },
      "importance": {
        "high": "Alto",
        "medium": "Medio",
        "low": "Basso"
      },
      "stepRecommendations": "Raccomandazioni"
    },
    "bidAdjustments": {
      "title": "Aggiustamenti delle offerte",
      "byDeviceType": {
        "title": "Per tipo di dispositivo",
        "table": {
          "deviceType": "Tipo di dispositivo",
          "wantedAdjustment": "Aggiustamento desiderato",
          "adjustedDefaultCost": "Costo",
          "adjustment": "Aggiustamento"
        }
      },
      "byWebsite": {
        "confirmRemoveWebsite": "Sei sicuro di voler rimuovere le modifiche del sito web {{name}}?",
        "title": "Per sito web",
        "table": {
          "website": "Sito web",
          "url": "URL",
          "adjustment": "Aggiustamento",
          "wantedAdjustment": "Aggiustamento desiderato",
          "calculateAdjustedDefaultCost": "Costo"
        },
        "searchInDirectory": {
          "title": "Siti web degli editori",
          "addWebsites": "Aggiungi aggiustamenti"
        }
      },
      "costLimit": {
        "min": "Il nuovo costo calcolato è inferiore al costo minimo di {{minCostByType}}. La regolazione salvata sarà {{realAdjustment}}%.",
        "max": "Il nuovo costo calcolato è superiore al costo massimo di {{maxCostByType}}. L'aggiustamento salvato sarà {{realAdjustment}}%."
      },
      "costValueOutsideLimits": "Il costo di questo gruppo di annunci non rientra nei limiti consentiti. Si prega di regolare il costo nelle impostazioni in modo che sia compreso tra i valori minimo e massimo."
    },
    "blacklistPage": {
      "description": "Elenco di tutti i siti Web in cui questo gruppo di annunci non può essere visualizzato perché l'editore lo ha inserito nella lista nera.",
      "trafficLost": "{{blacklistPercent}}% di traffico perso, {{finalPercent}}% di traffico rimanente",
      "website": "Sito web",
      "publisher": "Editore",
      "reseller": "Rivenditore",
      "reasons": "Ragioni"
    },
    "directory": {
      "title": "Preset di restrizione",
      "updated": "L'elenco delle restrizioni di trasmissione è stato aggiornato!",
      "cannotUpdateType": "Puoi aggiornare il tipo di restrizione solo se non esiste ancora alcuna restrizione",
      "addPosition": "Aggiungi posizioni",
      "presets": "Preset di restrizione di diffusione",
      "presetInventory": "Preset di restrizione di diffusione",
      "selectPresets": "Usa un preset",
      "selectPresetsTitle": "Seleziona preset di restrizione di diffusione",
      "convertToPreset": "Converti in preset",
      "convertToPresetTitle": "Converti l'elenco di restrizioni in preset",
      "parentCompany": "Società principale",
      "replaceWithPresetConfirm": "Sostituire l'elenco di restrizioni attuale con il preset {{name}}?",
      "replaceWithPresetApplied": "Preset applicato ed elenco di restrizioni cancellato",
      "managePresets": "Gestisci preset di restrizione di diffusione",
      "presetPreview": "{{websiteCount}} siti web, {{positionCount}} posizioni",
      "searchDirectory": {
        "title": "Siti web degli editori",
        "saved": "Siti web aggiunti con successo alla restrizione di trasmissione",
        "positions": "Posizioni",
        "presets": "Preset di restrizione di diffusione",
        "presetsSaved": "Preset di restrizione di diffusione aggiornati",
        "noPresets": "Nessun preset di restrizione di diffusione disponibile"
      },
      "directoryList": {
        "reseller": "Rivenditore",
        "impressions": "Traffico"
      },
      "incompatibleCreativesPosition": "Nessun creative attivo può essere veicolato su questa posizione.",
      "incompatibleCreativesWebsite": "Alcune posizioni di questo sito web non sono compatibili con i creative attivi.",
      "templateSizes": "Dimensioni template: {{sizes}}",
      "alert": {
        "veryLow": "Questo elenco di restrizioni include solo {{ percent }}% delle impressioni disponibili. Ti consigliamo di includere più siti web.",
        "low": "Questo elenco di restrizioni include solo {{ percent }}% delle impressioni disponibili.",
        "default": "Questo elenco di restrizioni include {{ percent }}% delle impressioni disponibili."
      }
    },
    "adPreview": {
      "label": "Sito web e posizione dell'annuncio",
      "info": "Seleziona una posizione per visualizzare un'anteprima",
      "channelTypeWarning": "Il gruppo di annunci deve avere un tipo di canale configurato",
      "noPositions": "Impossibile fare un'anteprima, nessuna posizione disponibile",
      "noActiveAdCopy": "Nessuna creatività attiva in questo gruppo di annunci.",
      "goToAdCopies": "Vai alla pagina delle creatività",
      "positionNotInDirectory": "La posizione selezionata non è compatibile con questo gruppo di annunci.",
      "adServerPreview": "Anteprima con AdServer",
      "preview": "Anteprima di AdCopy",
      "incompatibleAdCopies": "AdCopie incompatibili",
      "noCompatibleAdCopies": "Nessuna AdCopie compatibile",
      "minRequiredWidth": "Larghezza minima richiesta",
      "minRequiredHeight": "Altezza minima richiesta",
      "tooSmallBy": "{{label}} è troppo piccolo per {{value}}px"
    },
    "duplicateStatusWarning": "La copia verrà disabilitata. Dovrai attivarlo manualmente.",
    "analytics": {
      "import": "Aggiungi statistiche dall'analisi",
      "processingImport": "Elaborazione dell'importazione…",
      "rowsDetected": "Righe {{rows}}",
      "description": "Carica un file CSV contenente contenuti di analisi. Ogni voce deve essere posizionata su una nuova riga. ",
      "dropCsvFile": "Trascina qui il tuo file CSV",
      "dropCsvFileOr": "o",
      "success": "Importato con successo",
      "at": "Data",
      "adCopyId": "Creativo",
      "pageViews": "Visualizzazioni di pagina",
      "sessions": "Sessioni",
      "engagedSessions": "Sessioni impegnate",
      "totalUsers": "Utenti totali",
      "newUsers": "Nuovi utenti",
      "bounceRate": "Frequenza di rimbalzo",
      "engagementRate": "Tasso di coinvolgimento",
      "sessionTimeSeconds": "Orario della sessione",
      "cpv": "CPV",
      "viewOriginalFile": "Vedi il file originale",
      "originalFileTitle": "File originale: {{filename}}",
      "mapCreativesTooltip": "Abbina ciascun nome di creatività importata a una creatività in questo gruppo di annunci",
      "mapCreativesTitle": "Mappa creatività",
      "mapCreativesDescription": "Scegli quale creatività nel gruppo di annunci corrisponde a ciascun nome del tuo file.",
      "mapCreativesDecodeImportedNames": "Decodifica i nomi degli URL e sostituisci + con spazi",
      "mapCreativesFilter": "Filtra i nomi importati",
      "mapCreativesFilterHelper": "Lascia vuoto per includere tutti i nomi oppure scegli Annuncio*.",
      "mapCreativesFilterEmpty": "Nessun nome di creatività importata corrisponde a questo filtro.",
      "mapCreativesImportedName": "Nome importato",
      "mapCreativesMatchDoubleClickPlacementId": "Corrisponde all'ID posizionamento doppio clic",
      "mapCreativesMatchUtmContent": "Corrisponde al reindirizzamento utm_content",
      "mapCreativesMappedCount": "{{mapped}} / {{total}} mappato",
      "mapCreativesRemoveStatusText": "Rimuovi il testo di stato",
      "mapCreativesSelectedCreative": "Creatività del gruppo di annunci",
      "mapCreativesSettings": "Impostazioni corrispondenti",
      "mapCreativesEmpty": "Nessun nome di creatività trovato nei dati importati.",
      "showAllValues": "Mostra tutto",
      "atLeastOneCreativeMustBeImportable": "Mappa almeno una creatività importata con una data valida prima dell'importazione.",
      "missingStartDateWarning": "Le seguenti creatività non hanno una data di inizio e non sono state suddivise nell'intervallo di date: {{adCopies}}.",
      "sourceColumn": "Colonna",
      "sourceColumns": "Colonne",
      "mappingMode": "Modalità di mappatura",
      "calculation": "Calcolo",
      "formulaHelp": "Per le colonne delle statistiche, scegli una o più colonne dal file o crea un calcolo utilizzando le colonne del file.",
      "formulaInsertColumn": "Inserisci colonna",
      "formulaExpression": "Calcolo",
      "formulaPlaceholder": "Costruisci un calcolo dalle colonne del file",
      "formulaBuilderHelp": "Fai clic sulle colonne del file qui sopra per inserirle, quindi modifica il calcolo secondo necessità.",
      "formulaClear": "Calcolo chiaro",
      "formulaCreate": "Crea calcolo",
      "formulaEdit": "Modifica calcolo",
      "formulaModalHint": "Apri il builder per scegliere le colonne e visualizzare in anteprima i risultati.",
      "formulaTooltipHint": "Passa il mouse per vedere il calcolo corrente.",
      "formulaBuilderTitle": "Calcolo per {{field}}",
      "formulaModalDescription": "Costruisci il calcolo inserendo colonne dal file caricato. Gli esempi seguenti utilizzano le prime righe del file.",
      "formulaPreviewTitle": "Risultati di esempio",
      "formulaRow": "Fila",
      "formulaSampleValues": "Valori campione",
      "formulaResult": "Risultato",
      "formulaError": {
        "emptyExpression": "il calcolo è vuoto",
        "unknownHeader": "colonna sconosciuta",
        "ambiguousHeader": "nome della colonna ambiguo",
        "invalidSyntax": "calcolo non valido",
        "divisionByZero": "divisione per zero"
      },
      "allCreativesMustBeMapped_one": "Mappa ogni creatività importata a una creatività in questo gruppo di annunci prima dell'importazione. 1 creatività non mappata verrà ignorata.",
      "allCreativesMustBeMapped_other": "Mappa ogni creatività importata a una creatività in questo gruppo di annunci prima dell'importazione. {{count}} creatività non mappate verranno ignorate.",
      "showMappedValues_one": "Non mappato (1)",
      "showMappedValues_other": "Non mappato ({{count}})",
      "mapCreatives_one": "Mappa creatività (1)",
      "mapCreatives_other": "Mappa creatività ({{count}})",
      "formulaErrors_one": "1 errore di calcolo: {{errors}}",
      "formulaErrors_other": "{{count}} errori di calcolo: {{errors}}",
      "allCreativesMustBeMapped_many": "Mappa ogni creatività importata a una creatività in questo gruppo di annunci prima dell'importazione. {{count}} creatività non mappate verranno ignorate.",
      "showMappedValues_many": "Non mappato ({{count}})",
      "mapCreatives_many": "Mappa creatività ({{count}})",
      "formulaErrors_many": "{{count}} errori di calcolo: {{errors}}"
    },
    "reach": {
      "veryLow": "Questo gruppo di annunci include solo {{ percent }}% delle impressioni disponibili. Ti consigliamo di includere più siti web.",
      "low": "Questo gruppo di annunci include solo {{ percent }}% delle impressioni disponibili.",
      "default": "Questo gruppo di annunci include {{ percent }}% delle impressioni disponibili.",
      "info": "Queste informazioni non includono il targeting geografico e i segmenti.",
      "recommendedCpc": "CPC consigliato:"
    },
    "debug": {
      "title": "Debug del gruppo di annunci"
    },
    "rulesExceptionsSummary_one": "{{count}} paese accettato",
    "rulesExceptionsSummary_other": "{{count}} paesi accettati",
    "rulesExceptionsOff": "disattivata",
    "rulesExceptionsSummary_many": "{{count}} paesi accettati"
  },
  "campaign": {
    "sectionTitle": "Riepilogo della campagna",
    "advertiserDomainName": "Nome di dominio dell'inserzionista",
    "name": "Nome della campagna",
    "adGroupTaxonomy": {
      "title": "Gruppi di annunci e la loro tassonomia",
      "view": "Controlla la tassonomia degli AdGroups",
      "taxonomy": "Tassonomia"
    },
    "create": "Crea nuova campagna",
    "created": "Nuova campagna creata!",
    "updated": "La tua campagna è stata aggiornata!",
    "goToCampaign": "Vai a {{campaignName}}",
    "adgroupsHelper": "Aggiungi facoltativamente gruppi di annunci alla nuova campagna. Puoi aggiungerne più di uno prima di completare la creazione.",
    "copperOpportunity": "Opportunità Copper",
    "copperOpportunityStage": "Fase opportunità Copper",
    "copperOpportunityBudgetRemaining": "{{amount}} del budget dell'opportunità selezionata non sono ancora assegnati ai gruppi di annunci.",
    "spentBudget": {
      "messageStatus": {
        "leftBeforeDate": "| {{leftBudget}} rimasto prima del {{endDate}}",
        "leftThisMonth": "| {{leftBudget}} rimasto questo mese",
        "left": "| {{leftBudget}} rimasto"
      },
      "tooltip": {
        "monthly": "{{name}} — {{leftBudget}} rimasto questo mese",
        "period": "{{name}} — {{leftBudget}} rimasto nel periodo",
        "overall": "{{name}} — {{leftBudget}} rimasto complessivamente",
        "open": "{{name}} — nessun limite"
      },
      "warning": {
        "endDateSoon": "Questa campagna si fermerà tra {{daysThreshold}} giorni o meno.",
        "endOfMonthSoon": "Il budget mensile verrà reimpostato tra {{daysThreshold}} giorni o meno."
      }
    },
    "details": {
      "adGroups": "Gruppi di annunci",
      "advertiserDomainName": "Nome di dominio dell'inserzionista",
      "companyName": "Azienda",
      "marketCode": "Mercato",
      "resellerName": "Rivenditore",
      "domainName": "Dominio",
      "type": "Tipo",
      "stepperTitle": "Dettagli della campagna",
      "iabCategory": "Categoria IAB"
    },
    "analytics": {
      "sessions": "Sessioni",
      "session": "Sessione",
      "landing": "Landing",
      "lead": "Lead",
      "leadId": "ID lead",
      "orderId": "Codice ordine",
      "order": "Ordine",
      "iframe": "Iframe",
      "image": "Immagine",
      "tracking": {
        "title": "Tag Javascript",
        "tagVersions": "Versioni dei tag",
        "confirmationTags": "Tag di conferma",
        "sessionTags": "Tag di sessione",
        "confirmationWarning": "Un Tag di Sessione o di Landing deve già essere stato posizionato in precedenza sulla pagina di reindirizzamento del tuo annuncio per poter posizionare un Tag di conferma.",
        "mainWarning": "Si prega di utilizzare solo uno dei nostri tag per pagina.",
        "additionalLeadWarning": "Non dimenticare di aggiungere il valore Lead Id interno nel campo {lead-id}.",
        "additionalOrderWarning": "Non dimenticare di aggiungere il valore del tuo ID ordine interno in {order-id}, il valore dell'ordine in {order-value} e la valuta se non è EUR.",
        "lead": "Codice di monitoraggio da aggiungere alla pagina di conferma del lead.",
        "order": "Codice di monitoraggio da aggiungere alla pagina di conferma dell'ordine.",
        "replaceUnique": "deve essere sostituito da un unico",
        "replace": "deve essere sostituito da",
        "orderAmount": "importo dell'ordine",
        "orderAmountSeparator": "con un \".\" come separatore decimale.",
        "orderCurrency": "valuta dell'ordine",
        "orderCurrencyExample": "\"EUR\" per euro (€), \"USD\" per dollari americani ($).",
        "cspWarning": "Se il tuo sito utilizza una Content Security Policy (CSP), assicurati di autorizzare *.powerspace.com e *.pwspace.com nella direttiva script-src.",
        "cookiesUsed": "Questo tag utilizza i seguenti cookie per funzionare correttamente. Memorizzano informazioni tecniche anonime che ci consentono di misurare accuratamente sessioni e conversioni. Non è possibile tracciare lead o ordini senza questi cookie.",
        "cookieName": "Nome del cookie",
        "cookiePurpose": "Scopo",
        "cookieRetention": "Conservazione",
        "sendPageViews": "Invia le visualizzazioni di pagina",
        "cookies": {
          "pwqci": {
            "purpose": "ID clic: memorizza l'identificatore del clic dall'URL di reindirizzamento per rilevare il lead o l'ordine",
            "retention": "30 giorni"
          },
          "pstuid": {
            "purpose": "ID utente di monitoraggio Powerspace: identificatore utente univoco",
            "retention": "30 minuti"
          },
          "pwpv": {
            "purpose": "Visualizzazione pagina: memorizza l'URL di analisi crittografato con dati di sessione/visualizzazione di pagina",
            "retention": "30 minuti"
          }
        }
      },
      "serverTracking": {
        "title": "Da server a server",
        "mainWarning": "Si prega di fornire ulteriori informazioni.",
        "fullWarning": "Dovresti sostituire {clickId} con il valore trovato nel tuo URL dopo il reindirizzamento da Powerspace.",
        "parameters": {
          "clickId": {
            "description": "L'identificatore di clic dall'URL di reindirizzamento per rilevare il lead o l'ordine. Dovresti sostituire {clickId} con il valore trovato nel tuo URL dopo il reindirizzamento da Powerspace."
          },
          "orderValue": {
            "description": "L'importo dell'ordine con \".\" come separatore decimale."
          }
        },
        "headers": {
          "parameter": "Parametro",
          "description": "Descrizione",
          "required": "Obbligatorio"
        }
      },
      "standardTracking": {
        "title": "Tag di monitoraggio standard (obsoleti)"
      },
      "attributionSettings": {
        "title": "Impostazioni di attribuzione",
        "subtitle": "Impostazioni di attribuzione post clic",
        "confirmDialogTitle": "Sei sicuro ?",
        "confirmDialogMessage": "La modifica di questa impostazione influirà sul monitoraggio e nei report potrebbero essere visualizzate meno conversioni"
      }
    },
    "edit": {
      "sectionTitle": "Modifica campagna"
    },
    "segments": {
      "createdSuccess": "Nuovo segmento creato!",
      "updatedSuccess": "Segmento aggiornato!",
      "Created": "Creato",
      "Processed": "Elaborato",
      "Processing": "Elaborazione",
      "Error": "Errore",
      "Deleting": "Eliminazione",
      "profiles": "profili",
      "errors": {
        "UnsufficientValidLines": "righe valide insufficienti"
      },
      "nbProfilesInfo": "Questo segmento contiene {{nbProfiles}} profili",
      "reachInfo": "Copertura: {{reach}}%",
      "email": {
        "title": "Segmenti di posta elettronica",
        "lastModified": "Data dell'ultima modifica",
        "originalFilename": "Nome file originale",
        "uploadFile": "Carica nuovo file",
        "formatInfo": "Le email contenute nel file devono essere in lettere minuscole prima del caricamento.",
        "sampleFile": "È possibile scaricare un file di esempio",
        "fileType": ".csv o .txt accettati. Minimo 50 righe con 1 email per riga",
        "modal": {
          "title": "Gestisci segmento",
          "deleteTitle": "Conferma eliminazione segmento email",
          "delete": "Stai per eliminare il segmento {{segmentName}}. \nSei sicuro di voler procedere?"
        }
      },
      "behavioural": {
        "title": "Segmenti comportamentali",
        "manage": "Gestione comportamentale",
        "newSegment": "Crea nuovo segmento",
        "lastModified": "Data dell'ultima modifica",
        "duration": "Durata",
        "modal": {
          "title": "Crea segmento",
          "target": "Voglio targettizzare persone",
          "past": "Nel passato",
          "addRule": "Aggiungi regola",
          "oneRuleMini": "È necessaria almeno una regola",
          "delete": "Rimuovi segmento"
        }
      },
      "rules": {
        "VisitedWebsite": "che hanno visitato il sito web",
        "VisitedUrl": "che hanno visitato un URL specifico",
        "NotVisitedUrl": "che non hanno visitato un URL specifico",
        "VisitedUrlContaining": "che hanno visitato un URL contenente",
        "NotVisitedUrlContaining": "che non hanno visitato un URL contenente"
      },
      "Profiles": "profili"
    },
    "statusWarning": "La campagna {{name}} è stata interrotta.",
    "tabs": {
      "events": "Analisi e monitoraggio",
      "segments": "Segmenti",
      "dashboard": "Dashboard"
    },
    "segment": {
      "deleted": "Il segmento è stato eliminato"
    }
  },
  "adcopy": {
    "archived": "La tua creatività è stata archiviata!",
    "addVariation": "Aggiungi variazione",
    "create": "Aggiungi una creatività",
    "update": "Aggiorna questa creatività",
    "duplicate": "Duplica questa creatività",
    "duplicateInsteadOfUpdatePrefix": "Per confrontare le performance in modo più accurato, ti consigliamo di",
    "duplicateInsteadOfUpdateLink": "duplicare questa creatività",
    "duplicateInsteadOfUpdateSuffix": "invece di modificarla.",
    "created": "La tua creatività è stata creata!",
    "updated": "La tua creatività è stata aggiornata!",
    "updateWarning": "Le modifiche verranno abilitate entro un massimo di {{minutesNumber}} minuti",
    "settingsStep": "Impostazioni",
    "forceRedirectUrl": "Reindirizzamento dell'URL",
    "impressionPixels": "Pixel di impressione",
    "redirectUrl": "URL di reindirizzamento",
    "comments": "Commenti",
    "advertiserName": "Nome dell'inserzionista",
    "callToAction": "Invito all'azione",
    "copyWriting": "Creatività",
    "creationMode": "Modalità di creazione",
    "creationModeShuffle": "Mescola",
    "creationModeList": "Lista",
    "createVariantsInfo": "Puoi creare fino a {{max}} varianti della tua creatività facendo clic su \"aggiungi variante\" nei campi disponibili.",
    "abtestSelected": "Effettua un test A/B con questa creatività",
    "abTestWizardTitle": "Effettua un test A/B di questa creatività",
    "sameImageReused": "Questa variante riutilizzerà l'immagine originale della creatività selezionata.",
    "abTestExpectedFive": "Sono richiesti esattamente 5 contenuti (originale + 4 varianti).",
    "abTestTwoImagesRequired": "Fornisci 2 nuove immagini per le varianti 4 e 5.",
    "totalGeneratedAdCopies": "Totale di creatività {{number}}",
    "cropImage": "Ritaglia l'immagine",
    "chooseImage": "Scegli l'immagine",
    "chooseImages": "Scegli immagine/i",
    "availableSize": "Le dimensioni disponibili sono:",
    "image": "Immagine",
    "idealSize": "La dimensione ideale è 1200 x 628 (larghezza x altezza)",
    "widthAndHeight": "(larghezza x altezza)",
    "noImage": "Nessuna immagine",
    "cropNeeded": "Prima di salvare è necessario ritagliare l'immagine per ottenere le proporzioni corrette",
    "cropCloseWarning": "Se chiudi ora annullerai il ritaglio ed eliminerai questa immagine. Puoi continuare a modificarla per ritagliarla e salvarla.",
    "sizeLimit": "Il limite della dimensione dell'immagine è 2 MB",
    "sizeMiniError": "L'immagine non soddisfa i requisiti di dimensione minima.",
    "sizeMiniInfo": "La dimensione minima è {{minWidth}} x {{minHeight}} (larghezza x altezza)",
    "sizeMiniWarning": "Attenzione: la dimensione dell'immagine selezionata è inferiore al minimo consigliato. L'immagine verrà ridimensionata, il che potrebbe comportare una riduzione della qualità.",
    "imageCropperError": "Errore nel ritaglio immagine, riprova o contatta l'assistenza",
    "archiveConfirmation": "Vuoi davvero archiviare {{adCopyName}} ?",
    "cannotArchived": "Non sei autorizzato ad archiviare questo AdCopy perché è l'unico attivo",
    "badResolution": "La risoluzione dell'immagine non è valida",
    "adGroupOverride": "Sostituzione del gruppo di annunci",
    "adGroupOverrideTooltip": "Opzione specifica per questo adcopy, per impostazione predefinita queste informazioni sono le stesse del gruppo di annunci",
    "previewTable": {
      "title": "Creatività",
      "name": "Nome e anteprima",
      "weight": "Peso di diffusione",
      "schedule": "Programma",
      "scheduleFrom": "Da {{date}}",
      "scheduleUntil": "Fino a {{date}}",
      "scheduleRange": "{{startDate}} → {{endDate}}",
      "duplicateDialogTitle": "Duplicazione creativa",
      "duplicateConfirmation": "Desideri duplicare {{adCopyName}} ?",
      "createdAt": "Data di creazione",
      "updatedAt": "Ultimo cambiamento",
      "visualUpdatedAt": "Ultimo cambiamento visivo",
      "dates": "Date",
      "dateCreatedRelative": "Creato {{relative}}",
      "dateUpdatedRelative": "{{relative}} aggiornato",
      "dateTooltipSame": "Creato e ultima modifica visiva: {{date}}",
      "dateTooltipCreated": "Creato: {{date}}",
      "dateTooltipVisualUpdated": "Ultima modifica visiva: {{date}}",
      "since": "da allora",
      "errorStatusTooltip": "Si è verificato un errore con l'immagine attuale. Convertila in formato JPG (rinominare l'estensione del file non basta) e caricala di nuovo."
    },
    "archivedFilter": {
      "label": "Stato",
      "allStatus": "Tutti gli stati",
      "archived": "Archiviato"
    },
    "wizzard": {
      "max": "Caratteri massimi {{max}} - {{length}}/{{max}}",
      "betweenMinMax": "Dovrebbe essere compreso tra i caratteri {{min}} e {{max}}: {{length}}/{{max}}"
    },
    "dates": {
      "notToday": "Nessuna creatività attiva oggi",
      "startDateAndEndDateError": "Questo gruppo di annunci può iniziare solo il {{startDate}} e terminerà il {{endDate}}",
      "startDateError": "Sono attive solo le creatività con data di inizio futura, questo gruppo di annunci può iniziare solo su {{startDate}}",
      "endDatesError": "Sono attive solo le creatività con data di fine, questo gruppo di annunci verrà interrotto perché nessuna creatività sarà attiva dopo {{endDate}}"
    },
    "containsText": "L'immagine selezionata contiene testo. Ti consigliamo di utilizzare immagini senza testo per prestazioni migliori.",
    "keywordSuggestions": "Suggerimenti per le parole chiave",
    "noKeywordSuggestions": "Nessun suggerimento di parole chiave",
    "assistant": {
      "button": "Assistente AI",
      "title": "Assistente AI",
      "refresh": "Aggiorna",
      "remaining": "Slot {{count}} disponibili",
      "noSuggestions": "Nessun suggerimento disponibile.",
      "add": "Aggiungi alle varianti",
      "addAll": "Aggiungi tutti i suggerimenti"
    },
    "statusManager": {
      "step1": "Visualizza consigli",
      "stepBudgets": "Budget",
      "step2": "Aggiorna le creatività correnti",
      "stepAddNew": "Aggiungi nuove creatività",
      "stepOverview": "Panoramica e salvataggio",
      "budgetsStepTitle": "Budget del gruppo di annunci",
      "action_adcopies": "Gestisci lo stato delle creatività attive",
      "noActiveAdCopies": "Nessuna creatività attiva trovata",
      "recommended": "Consigliato",
      "display": {
        "cards": "Schede",
        "table": "Tabella"
      },
      "createNew": "Crea nuovi contenuti",
      "overviewStepTitle": "Panoramica prima del salvataggio",
      "overviewBudgets": "Budget",
      "overviewRuleBudgets": "Modifiche al budget basate su regole",
      "overviewStatuses": "Creatività attive",
      "overviewNewAdCopies": "Nuove creatività da creare",
      "overviewAdGroupChanges": "Impostazioni del budget",
      "overviewDemographicsChanges": "Targeting demografico",
      "overviewGeoTargetingChanges": "Targeting geografico",
      "overviewDeviceOsChanges": "Targeting per dispositivo e sistema operativo",
      "overviewTimeTargetingChanges": "Targeting temporale",
      "overviewStatusUpdates": "Aggiornamenti sullo stato del testo pubblicitario",
      "stepNoChanges": "Nessun cambiamento",
      "statusWillChange": "Lo stato verrà aggiornato",
      "noStatusChanges": "Nessun cambiamento di stato",
      "noChanges": "Nessun cambiamento",
      "noRecommendation": "Va tutto bene, nessuna raccomandazione per ora.",
      "partialSave": "Alcune modifiche sono state salvate. Errori: {{errors}}",
      "saveFailed": "Nessuna modifica salvata. Errori: {{errors}}",
      "saved": "Tutte le modifiche sono state salvate con successo",
      "action": {
        "action_budget": "Impostazioni del budget",
        "action_demographics": "Targeting demografico",
        "action_geoTargeting": "Targeting geografico",
        "action_deviceOs": "Targeting per dispositivo e sistema operativo",
        "action_timeTargeting": "Targeting temporale",
        "action_adcopies": "Aggiorna le copie degli annunci correnti"
      },
      "pendingIntegration": {
        "demographics": "L'integrazione del modulo per il targeting demografico è in sospeso. Questo passaggio ti consentirà di modificare il targeting per sesso e fascia di età in base ai consigli sulle regole.",
        "geoTargeting": "L'integrazione del modulo di targeting geografico è in sospeso. Questo passaggio ti consentirà di modificare il targeting per Paese, città e regione in base ai consigli sulle regole.",
        "deviceOs": "L'integrazione del modulo di targeting per dispositivo e sistema operativo è in sospeso. Questo passaggio ti consentirà di modificare il tipo di dispositivo e il targeting del sistema operativo in base ai suggerimenti delle regole.",
        "timeTargeting": "L'integrazione del modulo di targeting temporale è in sospeso. Questo passaggio ti consentirà di modificare il targeting per giorno e ora in base ai consigli delle regole."
      }
    },
    "deleted": "La tua creatività è stata eliminata!"
  },
  "adTemplate": {
    "Native": "Nativo",
    "Banner": "Stendardo",
    "Web": "Web",
    "notFound": "Modello non trovato",
    "size": "Dimensione",
    "edit": "Modifica template",
    "update": "Aggiorna un template",
    "updateWarning": "Le modifiche verranno abilitate entro un massimo di {{minutesNumber}} minuti",
    "duplicate": "Duplica questo template",
    "duplicateConfirmation": "Desideri duplicare {{adTemplateName}} ?",
    "deleteConfirmation": "Vuoi davvero eliminare {{adTemplateName}} ?",
    "cannotDeleteAdTemplate": "Non sei autorizzato a eliminare questo template perché è l'unico attivo su questa posizione",
    "created": "Il tuo template è stato creato!",
    "duplicated": "Il tuo template è stato duplicato!",
    "deleted": "Il tuo template è stato eliminato!",
    "updated": "Il tuo template è stato aggiornato!",
    "table": {
      "format": "Formato"
    },
    "web": {
      "cssSelector": "Selettore CSS",
      "cssSelectorPosition": "Posizione del selettore CSS",
      "preview": "Anteprima del template",
      "editor": "Editor web del template",
      "masterTemplate": "Maestro",
      "zoneTemplate": "Zona",
      "js": "Javascript",
      "css": "Css",
      "beautify": "Formatta il codice"
    },
    "preview": {
      "desktopPreview": "Anteprima sul desktop",
      "mobilePreview": "Anteprima mobile",
      "failed": "Errore: impossibile caricare l'anteprima",
      "reload": "Ricarica immagine(i)"
    },
    "create": {
      "title": "Crea un template"
    },
    "NotFound": "Template non trovato",
    "unknownFormat": "Questo tipo di template non è attualmente gestito dalla piattaforma"
  },
  "commons": {
    "accessType": "Tipo di accesso",
    "conversions": "Conversioni",
    "priority": "Priorità",
    "actions": {
      "add": "Aggiungere",
      "confirm": "Confermare",
      "confirmTheAction": "Conferma l'azione",
      "confirmDuplicate": "Sei sicuro di voler duplicare {{name}} ?",
      "confirmArchive": "Vuoi davvero archiviare {{name}} ?",
      "cancel": "Cancellare",
      "close": "Vicino",
      "changePassword": "Cambiare la password",
      "create": "Creare",
      "delete": "Eliminare",
      "downloadAsCsv": "Scarica come CSV",
      "archive": "Archivio",
      "back": "Indietro",
      "duplicate": "Duplicato",
      "hoverEditHelper": "Fare clic sui pulsanti sottostanti per attivare/disattivare l'elemento",
      "edit": "Modificare",
      "filter": "Filtro",
      "moreOptions": "Più opzioni",
      "save": "Salva",
      "selectAll": "Seleziona tutto",
      "deselectAll": "Deseleziona tutto",
      "activate": "Attivare",
      "disable": "Disabilita",
      "reject": "Rifiutare",
      "quitWithoutSaving": "Esci senza salvare",
      "selectFile": "Seleziona un file",
      "showMore": "Mostra di più",
      "showLess": "Mostra meno",
      "exportToXlsx": "Esporta in file Excel"
    },
    "sort": "Ordinare",
    "actionsTitle": "Azioni",
    "activityfeed": "Feed attività",
    "autoReload": {
      "label": "Ricarica automatica",
      "off": "Disattivato"
    },
    "adgroup": "Gruppo di annunci",
    "adgroups": "Gruppi di annunci",
    "admin": "Admin",
    "adTemplates": "Modelli",
    "all": "Tutto",
    "active": "Attivo",
    "inactive": "Inattivo",
    "paused": "In pausa",
    "pending": "In attesa",
    "nobudgetleft": "Nessun budget rimasto",
    "pendingvalidation": "In attesa di convalida",
    "rejected": "Respinto",
    "processing": "Elaborazione",
    "waiting": "In attesa",
    "archived": "Archiviato",
    "ended": "Terminato",
    "startsoon": "Inizierà a breve",
    "campaign": "Campagna",
    "campaigns": "Campagne",
    "companies": "Aziende",
    "companyName": "Azienda",
    "create": "Creare",
    "creative": "Creativo",
    "comingSoon": "Questa funzionalità sarà presto disponibile",
    "days": "Giorni",
    "default": "Predefinito",
    "details": "Dettagli",
    "desktop": "Desktop",
    "deleted": "Eliminato",
    "disabled": "Disabilitato",
    "domainFormatError": "Verifica che il tuo dominio sia formattato correttamente",
    "email": "E-mail",
    "emptyData": "Nessun dato trovato",
    "emptyField": "Nessuno",
    "entityType": "Tipo di entità",
    "enabled": "Abilitato",
    "error": "Errore",
    "errorOccurred": "Si è verificato un errore",
    "exclude": "escludere",
    "firstName": "Nome di battesimo",
    "fullName": "Nome",
    "format": "formato",
    "goTo": "Vai a {{item}}",
    "iabCategory": "Categoria IAB",
    "recommendedIabCategoryAlert": "Categoria IAB consigliata: {{category}}",
    "id": "ID",
    "include": "includere",
    "integer": "Il valore dovrebbe essere un numero intero",
    "invited": "Invitato",
    "invalidUrl": "URL non valido",
    "urlCheck": {
      "redirectsTo": "Questo URL reindirizza a {{url}}",
      "redirectDetected": "Questo URL reindirizza altrove (destinazione non leggibile)",
      "httpError": "Verifica URL non riuscita con codice HTTP {{status}}",
      "expiredCertificate": "Impossibile verificare l'URL: il certificato SSL del sito è scaduto",
      "requestFailed": "Impossibile verificare l'URL (errore di rete o blocco del browser)"
    },
    "lastName": "Cognome",
    "login": "Login",
    "manager": "Manager",
    "market": "Mercato",
    "mobile": "Mobile",
    "modified": "Modificato",
    "nonArchived": "Non archiviato",
    "saved": "Le tue modifiche sono state salvate",
    "savedWithDelay": "Le modifiche verranno abilitate entro un massimo di {{minutesNumber}} minuti",
    "name": "Nome",
    "noValueYet": "Nessun valore ancora",
    "no": "NO",
    "noDataToDisplay": "Nessuna selezione ancora",
    "password": "Password",
    "publishers": "Editori",
    "phone": "Telefono",
    "primaryContact": "Contatto principale",
    "pageNumber": "Pagina n°{{currentPage}}",
    "reports": "Report",
    "reseller": "Rivenditore",
    "required": "Campo obbligatorio",
    "retry": "Riprova",
    "rowsPerPage": "righe per pagina",
    "startDate": "Data di inizio",
    "endDate": "Data di fine",
    "settingsTitle": "Impostazioni",
    "paginationDisplayedRows_one": "{{from}}–{{to}} di 1",
    "paginationDisplayedRows_other": "{{from}}–{{to}} di {{count}}",
    "atLeastOneOption": "Seleziona almeno un'opzione",
    "budget": "Budget",
    "status": "Stato",
    "derivedStatus": {
      "adGroups": "Questo stato riflette solo lo stato dei gruppi di annunci. È attivo quando almeno un gruppo di annunci è attivo. Per disattivarlo, disattiva tutti i gruppi di annunci.",
      "positions": "Questo stato riflette solo lo stato delle position. È attivo quando almeno una position è attiva. Per disattivarlo, disattiva tutte le position."
    },
    "dashboard": "pannello di controllo",
    "settings": "impostazioni",
    "stepper": {
      "back": "Indietro",
      "next": "Prossimo",
      "skip": "Saltare",
      "submit": "Invia",
      "submitting": "Invio",
      "checkRecommendations": "Controlla questi consigli"
    },
    "title": "Titolo",
    "description": "Descrizione",
    "tooltips": {
      "limitExceeded": "altri elementi"
    },
    "unknown": "Sconosciuto",
    "unsavedModifications": "Campi con modifiche non salvate:",
    "unsavedChangesWarning": "Sei sicuro di voler lasciare questa pagina senza salvare?",
    "closeDialogWithoutSaving": "Sei sicuro di voler chiudere questa finestra di dialogo senza salvare?",
    "user": "utente",
    "users": "Utenti",
    "websites": "Siti web",
    "hour": "Ora",
    "day": "Giorno",
    "week": "Settimana",
    "month": "Mese",
    "year": "Anno",
    "yes": "SÌ",
    "endDateValidation": "La data di fine non può essere anteriore alla data di inizio",
    "validation": {
      "minWithCount": "{{name}} deve contenere almeno {{min}} caratteri: {{length}}/{{max}}",
      "maxWithCount": "{{name}} deve contenere al massimo {{max}} caratteri: {{length}}/{{max}}",
      "numberMin": "deve essere maggiore o uguale a {{min}}",
      "numberMax": "deve essere minore o uguale a {{max}}"
    },
    "noDataAvailable": "Nessun dato disponibile",
    "errors": {
      "generic": "Si è verificato un errore"
    },
    "revenue": "Entrate",
    "ctr": "CTR",
    "cpm": "CPM",
    "clicks": "Clic",
    "impressions": "Impressioni",
    "leads": "Lead",
    "orders": "Ordini",
    "costs": "Costi",
    "adcopies": "creativi",
    "toolbar": {
      "selectedCount_one": "{{count}} selezionato",
      "selectedCount_other": "{{count}} selezionati"
    },
    "paginationDisplayedRows_many": "{{from}}–{{to}} di {{count}}"
  },
  "company": {
    "billing": {
      "bankDetails": "Coordinate bancarie",
      "bankName": "Nome della banca",
      "currency": "Valuta predefinita",
      "edit": {
        "title": "Edizione dei dettagli di fatturazione"
      },
      "iban": "IBAN",
      "invoiceLanguage": "Lingua della fattura",
      "invoiceSettings": "Impostazioni fattura",
      "invoicingCompany": "Entità di fatturazione",
      "paymentTerm": "Termini di pagamento",
      "sectionTitle": "Fatturazione",
      "stepperTitle": "Dettagli di fatturazione",
      "swift": "SWIFT/BIC"
    },
    "billingContacts": {
      "createDialogTitle": "Crea contatto per la fatturazione",
      "created": "Il contatto per la fatturazione è stato creato correttamente",
      "deleteConfirm": "Stai per eliminare il seguente contatto di fatturazione: {{firstName}} {{lastName}}. \nSei sicuro di voler procedere?",
      "deleteDialogTitle": "Elimina la conferma del contatto per la fatturazione",
      "helperTooltip": "Contatti aggiuntivi per notifiche di fatturazione/fattura",
      "sectionTitle": "Contatti per la fatturazione"
    },
    "cgu": {
      "accept": "Accettare",
      "accepted": "Accettato",
      "acceptCguMessage": "Per continuare a utilizzare l'applicazione, è necessario accettare i nostri Termini e Condizioni.",
      "inherited": {
        "agency": "Queste condizioni sono gestite dall'agenzia parent.",
        "agencyOrReseller": "Queste condizioni sono gestite dall'agenzia o dal rivenditore parent.",
        "link": "Consultale lì.",
        "reseller": "Queste condizioni sono gestite dal rivenditore parent."
      },
      "newCguVersionMessage": "I nostri Termini e Condizioni sono stati aggiornati. Si prega di leggere la nuova versione e accettarla per continuare a utilizzare i nostri servizi.",
      "notAccepted": "Non ancora accettato"
    },
    "create": "Crea azienda",
    "created": "La società è stata creata correttamente",
    "usersHelper": "Aggiungi facoltativamente utenti alla nuova azienda. Puoi aggiungerne più di uno prima di completare la creazione.",
    "details": {
      "accountingId": "Identificativo contabile",
      "address": "Indirizzo",
      "city": "Città",
      "companyType": "Tipo di azienda",
      "contact": "Contatto",
      "copperOpportunity": "Opportunità",
      "copperOpportunityStage": "Fase opportunità Copper",
      "country": "Paese",
      "edit": {
        "title": "Edizione dei dettagli aziendali",
        "vatHelper": "La partita IVA è convalidata in base al Paese"
      },
      "fax": "Fax",
      "nameAndGeneric": "Nome (Nome generico)",
      "genericName": "Nome generico",
      "map": "Mappa",
      "name": "Nome dell'azienda",
      "nameAlreadyExists": "Un'azienda con questo nome esiste già",
      "phone": "Telefono",
      "agency": "Agenzia",
      "reseller": "Rivenditore",
      "resellerId": "Rivenditore",
      "resellerName": "Rivenditore",
      "sectionTitle": "Dettagli aziendali",
      "slug": "Sottodominio aziendale",
      "stepperTitle": "Dettagli dell'azienda",
      "taxDetails": "Dettagli fiscali",
      "taxId": "Codice fiscale",
      "type": "Tipo",
      "vatId": "Partita IVA",
      "website": "Sito web",
      "zipCode": "Cap"
    },
    "managers": {
      "accountManager": "Account Manager",
      "salesManager": "Direttore delle vendite",
      "stepperTitle": "Manager"
    },
    "rights": {
      "api": "Api",
      "web": "Canale web",
      "adgroupCpm": "CPM",
      "adgroupCpl": "CPL",
      "adgroupCpc": "CPC",
      "adgroupExclusions": "Restrizione alla trasmissione",
      "adgroupCustomcpcs": "Aggiustamenti delle offerte",
      "adgroupReportwebsites": "Visualizza il rapporto per sito web",
      "adgroupUsertargeting": "Targeting demografico",
      "adgroupGeotargeting": "Targeting geografico",
      "adgroupDevicetargeting": "Targeting per dispositivo",
      "adgroupTimetargeting": "Targeting per ora e giorno",
      "adgroupPriority": "Priorità del gruppo di annunci",
      "adgroupMonthlyBudgetCapping": "Mensile",
      "adgroupOverallBudgetCapping": "Complessivo",
      "adgroupOpenBudgetCapping": "Senza limite",
      "adgroupPeriodBudgetCapping": "Periodo",
      "adgroupBudgetCapping": "Limite di budget",
      "adgroupOpenDailyBudget": "Budget giornaliero aperto",
      "adgroupDatesRequired": "Date di inizio e fine obbligatorie",
      "costSettings": "Impostazioni costo",
      "budgetCappingSettings": "Impostazioni limite di budget",
      "disabledRequiresBudgetCapping": "Attiva il limite di budget per modificare questa autorizzazione.",
      "adgroupSegments": "CRM per segmenti",
      "adgroupAutoSegments": "Segmentazioni automatiche",
      "adCopyDates": "Date del testo pubblicitario",
      "positionAdvancedsettings": "Impostazioni avanzate della posizione (CPM Floor, Rev. share)",
      "websiteExclusions": "Esclusioni campagne siti web",
      "advertiserDirectoryPresets": "Preset di directory",
      "publisherBlacklistPresets": "Preset di blacklist",
      "description": {
        "api": "Visualizza la pagina token API e percorsi",
        "web": "Visualizzazione del canale web",
        "banner": "Visualizzazione del modello banner",
        "adgroupCpm": "Visualizzazione del costo CPM",
        "adgroupCpl": "Visualizzazione del costo CPL",
        "adgroupExclusions": "Visualizzazione della pagina di restrizione della trasmissione o targeting di siti Web e posizioni per gruppi di annunci",
        "adgroupCustomcpcs": "Visualizza la pagina per aggiungere aggiustamenti delle offerte personalizzati per sito web, dispositivo o categoria iab",
        "adgroupReportwebsites": "Pagina delle statistiche del gruppo di annunci per sito web visibile.",
        "adgroupUsertargeting": "Visualizzazione del targeting demografico visibile.",
        "adgroupGeotargeting": "Visualizzazione del targeting geografico visibile.",
        "adgroupDevicetargeting": "Visualizzazione del targeting per dispositivo visibile.",
        "adgroupTimetargeting": "Visualizzazione del targeting per ora e giorno visibile.",
        "adgroupPriority": "Consente a questo rivenditore di dare priorità ai propri annunci rispetto a Powerspace.",
        "adgroupMonthlyBudgetCapping": "Consente il limite di budget mensile sui gruppi di annunci.",
        "adgroupOverallBudgetCapping": "Consente il limite di budget complessivo sui gruppi di annunci.",
        "adgroupOpenBudgetCapping": "Consente il limite di budget aperto (illimitato) sui gruppi di annunci.",
        "adgroupBudgetCapping": "Consente tipo e importo del limite di budget sui gruppi di annunci.",
        "adgroupOpenDailyBudget": "Consente il budget giornaliero aperto sui gruppi di annunci.",
        "adgroupDatesRequired": "Richiede date di inizio e fine sui gruppi di annunci.",
        "costSettings": "Tipi di costo consentiti per i gruppi di annunci. Il CPC è sempre attivo; CPM e CPL sono opzionali.",
        "budgetCappingSettings": "Tipi di limite di budget consentiti per i gruppi di annunci. Il periodo è sempre attivo; mensile, complessivo e aperto sono opzionali.",
        "adgroupSegments": "Pagina dei segmenti CRM visibili.",
        "adgroupAutoSegments": "Segmentazioni automatiche visibili nei gruppi di annunci.",
        "adCopyDates": "Abilita l'utilizzo delle date di inizio e fine di AdCopy.",
        "positionAdvancedsettings": "Pagina delle impostazioni avanzate della posizione (CPM Floor, Rev. share) visibile.",
        "websiteExclusions": "Visualizzazione della pagina delle esclusioni dei siti web.",
        "advertiserDirectoryPresets": "Crea e gestisci i preset di directory dell'inserzionista.",
        "publisherBlacklistPresets": "Crea, assegna e converti i preset di blacklist."
      },
      "admin": "Admin",
      "edit": "Modifica",
      "read": "Lettura",
      "banner": "Modello di bandiera",
      "sectionTitle": "Accesso e diritti",
      "uiRightsMainTitle": "Accesso principale",
      "uiRightsTitle": "Accesso e diritti",
      "groups": {
        "adCopy": "AdCopy",
        "position": "Posizione",
        "website": "Sito web",
        "presets": "Preset",
        "apiAccess": "API",
        "channels": "Canali",
        "budget": "Budget",
        "targeting": "Targeting",
        "segments": "Segmenti",
        "broadcast": "Diffusione e offerte",
        "priority": "Priorità"
      },
      "inherited": {
        "agency": "Questi diritti sono gestiti dall'agenzia parent. Consultali lì.",
        "reseller": "Questi diritti sono gestiti dal rivenditore parent. Consultali lì.",
        "agencyOrReseller": "Questi diritti sono gestiti dall'agenzia o dal rivenditore parent. Consultali lì.",
        "generic": "Questi diritti non possono essere modificati qui."
      },
      "presets": {
        "label": "Preset diritti",
        "title": "Preset diritti",
        "description": "Applica un insieme predefinito di permessi inserzionista. Le modifiche restano nel modulo fino al salvataggio.",
        "self": "Self",
        "managed": "Managed",
        "all": "All"
      }
    },
    "users": {
      "accessType": "Tipo di accesso",
      "actions": "Azioni",
      "createUser": "Crea utente",
      "created": "L'utente è stato creato correttamente",
      "deleted": "L'utente è stato eliminato",
      "deleteConfirm": "Stai per eliminare definitivamente il seguente utente: {{firstName}} {{lastName}}\nSei sicuro di voler procedere?\n\nUna volta eliminati, tutte le informazioni di contatto e di accesso di questo utente verranno eliminate.",
      "deleteDialogTitle": "Elimina la conferma dell'utente",
      "edit": {
        "form": {
          "changePassword": "Cambiare la password",
          "passwordUpdated": "La tua password è stata aggiornata",
          "errors": {
            "digit": "Una cifra",
            "lowercase": "Una minuscola",
            "max": "Massimo {{max}} caratteri",
            "min": "Minimo {{min}} caratteri",
            "special": "Un carattere speciale",
            "uppercase": "Una maiuscola"
          },
          "newPassword": "Nuova password",
          "passwordSecure": "La tua password è sicura!",
          "passwordBestPractices": {
            "title": "Buone pratiche per le password",
            "passphrase": "Usa una password lunga composta da più parole non collegate tra loro.",
            "reuse": "Non riutilizzare una password già usata su altri siti.",
            "personalInfo": "Evita informazioni personali come il tuo nome, la tua azienda o il tuo indirizzo e-mail.",
            "passwordManager": "Valuta l'uso di un gestore di password per generare e conservare le tue password."
          }
        },
        "title": "Modifica utente"
      },
      "email": "E-mail",
      "emailAlreadyUsed": "Questa email è già utilizzata",
      "externalAccess": {
        "agency": "Agenzia",
        "revokeAccess": "Revoca accesso",
        "title": "Accesso esterno"
      },
      "firstName": "Nome",
      "invite": "Invita utente",
      "invited": "L'utente è stato invitato",
      "sendInvitation": "Invia un invito",
      "isAdmin": "Admin",
      "jobTitle": "Titolo di lavoro",
      "lastName": "Cognome",
      "language": "Lingua",
      "languages": {
        "en": "Inglese",
        "fr": "francese",
        "it": "Italiano"
      },
      "mobile": "Telefono",
      "passwordValidation": "Convalida della password",
      "primaryContact": "Contatto principale",
      "primaryContactYes": "Sì",
      "primaryContactNo": "No",
      "sectionTitle": "Utente",
      "stepperTitle": "Utenti",
      "userInfos": "Informazioni utente",
      "preferences": "Preferenze",
      "market": "Mercato predefinito",
      "roles": "Ruoli"
    },
    "statusWarning": "La società {{name}} è inattiva.",
    "tabs": {
      "billing": "Fatturazione",
      "users": "Utenti",
      "access": "Accesso e diritti",
      "terms": "Termini e Condizioni",
      "api": "API",
      "directoryPresets": "Preset di restrizione di diffusione",
      "revshare": "Revshare"
    },
    "revshare": {
      "averageTitle": "Revenue share medio",
      "website": "Sito web",
      "aboveAverage": "Sopra la media",
      "belowAverage": "Sotto la media",
      "bulkUpdateAction": "Aggiorna revshare selezionati",
      "bulkUpdateTitle": "Aggiorna revenue share",
      "bulkUpdateSubmit_one": "Applica a {{count}} posizione",
      "bulkUpdateSubmit_other": "Applica a {{count}} posizioni",
      "bulkUpdateSubmit_many": "Applica a {{count}} posizioni"
    },
    "settings": {
      "defaultPriority": "Priorità predefinita",
      "defaultPriorityHelper": "Priorità predefinita per i tuoi gruppi di annunci",
      "priorities": "Priorità del gruppo di annunci",
      "addPriority": "Aggiungi una priorità",
      "priorityDefaultName": "Nuova priorità",
      "duplicatePriorities": "Lo stesso nome viene utilizzato più volte",
      "usedPriorityDeletion": "Impossibile eliminare una priorità utilizzata",
      "defaultPriorityDeletion": "Impossibile eliminare la priorità predefinita",
      "priorityIndexHelper": "Un gruppo di annunci con priorità 1 verrà visualizzato prima di un gruppo di annunci con priorità 2",
      "movePriorityUp": "Sposta priorità su",
      "movePriorityDown": "Sposta priorità giù",
      "bannerSizes": "Dimensioni banner",
      "addBannerSize": "Aggiungi una dimensione banner",
      "addBannerSizeModalTitle": "Aggiungi una dimensione banner",
      "uploadBannerImage": "Carica un'immagine",
      "uploadBannerImageHelper": "Carica un'immagine banner per rilevare larghezza e altezza, quindi modifica i valori se necessario.",
      "bannerImageUploadError": "Impossibile leggere l'immagine caricata.",
      "duplicateBannerSizes": "Le stesse dimensioni sono utilizzate più volte",
      "invalidBannerSize": "Larghezza e altezza devono essere numeri interi positivi",
      "bannerSizesEmpty": "Nessuna dimensione banner configurata",
      "bannerSizePreview": "Anteprima"
    },
    "copper": {
      "sectionTitle": "Copper"
    },
    "archiver": {
      "title": "Archiviazione automatica",
      "helper": "Per gli inserzionisti, i valori ereditati dall'agenzia e dal rivenditore padre vengono mostrati automaticamente. Inserisci 0 per disabilitare l'archiviazione automatica per quel tipo di entità.",
      "inherit": "Eredita dal rivenditore",
      "unit_one": "mese",
      "unit_other": "mesi",
      "disabled": "Disabilitato",
      "invalidMonths": "Inserisci un numero intero di mesi maggiore o uguale a 0.",
      "months_one": "{{count}} mese",
      "months_other": "{{count}} mesi",
      "fields": {
        "adcopyMonths": "Creatività",
        "adgroupMonths": "Gruppi di annunci",
        "adtemplateMonths": "Modelli pubblicitari",
        "positionMonths": "Posizioni"
      },
      "months_many": "{{count}} mesi",
      "unit_many": "mesi"
    },
    "webhooks": {
      "title": "Webhook",
      "url": "URL webhook",
      "types": "Tipi di evento",
      "urlHelper": "Il tuo endpoint riceve una richiesta POST con un payload JSON quando cambia lo stato di un ad group.",
      "eventType": "Tipo di evento",
      "eventTypeHelper": "Evento: {{eventType}}. Nome evento del payload: adgroup.status.changed.",
      "addWebhook": "Aggiungi un webhook",
      "saveSuccess": "Webhook salvati con successo.",
      "deleteSuccess": "Webhook eliminato con successo.",
      "invalidUrl": "Inserisci un URL valido",
      "typesRequired": "Seleziona almeno un tipo di evento",
      "duplicateUrls": "Lo stesso URL è utilizzato più volte",
      "empty": "Nessun webhook configurato",
      "documentation": {
        "title": "Documentazione",
        "open": "Documentazione",
        "versionLabel": "Versione",
        "versionOption": "Versione {{version}}"
      }
    },
    "api": {
      "token": {
        "title": "Token API",
        "create": "Crea nuovo token",
        "token": "Token",
        "createdAt": "Data di creazione",
        "empty": "Nessun token"
      },
      "routes": {
        "title": "Percorsi",
        "noData": "Nessun dato per questo giorno",
        "parameter": {
          "date": "Dovrebbe essere la data dei dati che desideri ottenere nel formato AAAA-MM-GG",
          "dateIcon": "Cambia la data",
          "token": "Può essere sostituito da qualsiasi token dell'azienda."
        }
      }
    }
  },
  "enum": {
    "AdFormat": {
      "Banner": "Banner",
      "Native": "Native",
      "Web": "Web"
    },
    "BiddingStrategy": {
      "MaxCpm": "Offerta olistica (massimizzazione del CPM)"
    },
    "ChannelType": {
      "Email": "E-mail",
      "Web": "Web"
    },
    "CompanyType": {
      "Advertiser": "Inserzionista",
      "Agency": "Agenzia",
      "Publisher": "Editore",
      "Reseller": "Rivenditore",
      "TradingDesk": "Trading Desk"
    },
    "CompanyWebhookType": {
      "AdGroupStatus": "Stato ad group"
    },
    "EntityType": {
      "AdCopy": "Creatività",
      "AdGroup": "Adgroup",
      "AdGroupBudgetPlan": "Piano di budget",
      "AdGroupTargeting": "Targeting Adgroup",
      "AdTemplate": "Template annuncio",
      "AdTemplateBanner": "Template banner",
      "AdTemplateImage": "Template immagine",
      "AdTemplateNative": "Template native",
      "AdTemplateWeb": "Template web",
      "AdgroupCustomCost": "Costo personalizzato",
      "AdgroupDirectory": "Restrizione di diffusione",
      "AdgroupNetworkExtension": "Rete Adgroup",
      "AdgroupWebsiteDirectory": "Directory Adgroup",
      "AdgroupWebsiteExclusion": "Directory Adgroup",
      "Advertiser": "Inserzionista",
      "Agency": "Agenzia",
      "BillingContact": "Contatto di fatturazione",
      "Campaign": "Campagna",
      "Company": "Azienda",
      "CompanyApiToken": "Token API",
      "CompanyArchiver": "Politica di archiviazione automatica",
      "CompanyWebhook": "Webhook",
      "InventorySelection": "Selezione inventario",
      "Position": "Posizione",
      "PositionEmail": "Posizione",
      "PositionWeb": "Posizione",
      "ProgrammaticCampaign": "Campagna programmatica",
      "Publisher": "Editore",
      "PublisherExclusionPreset": "Preset di esclusione",
      "Reseller": "Rivenditore",
      "Segment": "Segmento",
      "SegmentBehavioural": "Segmento",
      "SegmentFile": "Segmento",
      "TradingDesk": "Trading desk",
      "User": "Utente",
      "Website": "Sito web",
      "WebsiteCampaignExclusion": "Esclusione campagna",
      "WebsiteDomainExclusion": "Esclusione dominio",
      "WebsiteIabExclusion": "Esclusione IAB",
      "AdGroupDirectoryPreset": "Preset di restrizione"
    },
    "Currency": {
      "EUR": "EUR"
    },
    "IntegrationType": {
      "Direct": "Diretto"
    },
    "InvoiceLanguage": {
      "en": "Inglese",
      "fr": "francese"
    },
    "InvoicingCompany": {
      "PowerspaceSAS": "Powerspace SAS",
      "WelcomeMediaSAS": "Welcome Media SAS"
    },
    "Network": {
      "Ecommerce": "E-commerce",
      "Eshopper": "Eshopper",
      "Media": "Media",
      "Performance": "Performance",
      "Ebusiness": "E-business"
    },
    "PositionType": {
      "InContent": "Nel contenuto",
      "InFeed": "Nel feed",
      "RecommandationWidget": "Widget di raccomandazione",
      "SideContent": "Contenuto laterale"
    },
    "SubChannelType": {
      "ConfirmationPage": "Pagina di conferma",
      "Newsletter": "Notiziario",
      "OrderConfirmationEmail": "E-mail di conferma dell'ordine",
      "ProductListing": "Elenco prodotti"
    },
    "SslStatus": {
      "Invalid": "Non valido",
      "NotLinked": "Non collegato",
      "Pending": "In attesa di",
      "Valid": "Valido"
    },
    "genre": {
      "male": "Maschio",
      "female": "Femmina"
    },
    "AdvertiserGestion": {
      "Self": "Se stesso",
      "Managed": "Gestito"
    },
    "AdvertiserType": {
      "Direct": "Diretto",
      "AgencyPerformance": "Agenzia per lo spettacolo",
      "AgencyMedia": "Agenzia mediatica",
      "AffiliationPlatform": "Piattaforma di affiliazione"
    },
    "UserRole": {
      "Finance": "Finanza",
      "Marketing": "Marketing",
      "Sales": "Saldi",
      "PublisherAccount": "Conto editore",
      "Tech": "Tecnologia",
      "Traffic": "Traffico"
    },
    "BudgetCapping": {
      "Monthly": "Mensile",
      "Overall": "Complessivamente",
      "Open": "Nessun limite",
      "Period": "Periodo"
    },
    "Gender": {
      "Male": "Maschio",
      "Female": "Femmina",
      "Unknown": "Sconosciuto"
    },
    "DeviceType": {
      "Desktop": "Desktop",
      "Mobile": "Mobile",
      "Tablet": "Tablet",
      "Unknown": "Sconosciuto"
    },
    "OsType": {
      "Android": "Android",
      "Ios": "iOS",
      "Macos": "macOS",
      "Windows": "Windows",
      "Unknown": "Sconosciuto"
    },
    "Day": {
      "Monday": "Lunedì",
      "Tuesday": "Martedì",
      "Wednesday": "Mercoledì",
      "Thursday": "Giovedì",
      "Friday": "Venerdì",
      "Saturday": "Sabato",
      "Sunday": "Domenica"
    }
  },
  "iabCategories": {
    "IAB1": "Arte e intrattenimento",
    "IAB1-1": "Libri e letteratura",
    "IAB1-2": "Fan/pettegolezzi di celebrità",
    "IAB1-3": "Belle Arti",
    "IAB1-4": "Umore",
    "IAB1-5": "Film",
    "IAB1-6": "Musica",
    "IAB1-7": "Televisione",
    "IAB10": "Casa e giardino",
    "IAB10-1": "Elettrodomestici",
    "IAB10-2": "Divertente",
    "IAB10-3": "Sicurezza ambientale",
    "IAB10-4": "Giardinaggio",
    "IAB10-5": "Riparazione domestica",
    "IAB10-6": "Teatro domestico",
    "IAB10-7": "Decorazione d'interni",
    "IAB10-8": "Paesaggistica",
    "IAB10-9": "Rimodellamento e costruzione",
    "IAB11": "Legge, governo e politica",
    "IAB11-1": "Immigrazione",
    "IAB11-2": "Questioni legali",
    "IAB11-3": "Risorse del governo degli Stati Uniti",
    "IAB11-4": "Politica",
    "IAB11-5": "Commento",
    "IAB12": "Notizia",
    "IAB12-1": "Notizie internazionali",
    "IAB12-2": "Notizie nazionali",
    "IAB12-3": "Notizie locali",
    "IAB13": "Finanza personale",
    "IAB13-1": "Inizio ad investire",
    "IAB13-10": "Pianificazione pensionistica",
    "IAB13-11": "Azioni",
    "IAB13-12": "Pianificazione fiscale",
    "IAB13-2": "Credito/debito e prestiti",
    "IAB13-3": "Notizie finanziarie",
    "IAB13-4": "Pianificazione finanziaria",
    "IAB13-5": "Fondo speculativo",
    "IAB13-6": "Assicurazione",
    "IAB13-7": "Investire",
    "IAB13-8": "Fondi comuni",
    "IAB13-9": "Opzioni",
    "IAB14": "Società",
    "IAB14-1": "Incontri",
    "IAB14-2": "Supporto al divorzio",
    "IAB14-3": "Vita gay",
    "IAB14-4": "Matrimonio",
    "IAB14-5": "Vita da anziani",
    "IAB14-6": "Adolescenti",
    "IAB14-7": "Matrimoni",
    "IAB14-8": "Specifico etnico",
    "IAB15": "Scienza",
    "IAB15-1": "Astrologia",
    "IAB15-10": "Meteo",
    "IAB15-2": "Biologia",
    "IAB15-3": "Chimica",
    "IAB15-4": "Geologia",
    "IAB15-5": "Fenomeni paranormali",
    "IAB15-6": "Fisica",
    "IAB15-7": "Spazio/Astronomia",
    "IAB15-8": "Geografia",
    "IAB15-9": "Botanica",
    "IAB16": "Animali domestici",
    "IAB16-1": "Acquari",
    "IAB16-2": "Uccelli",
    "IAB16-3": "Gatti",
    "IAB16-4": "Cani",
    "IAB16-5": "Grandi animali",
    "IAB16-6": "Rettili",
    "IAB16-7": "Medicina Veterinaria",
    "IAB17": "Sport",
    "IAB17-1": "Corse automobilistiche",
    "IAB17-10": "Pattinaggio di figura",
    "IAB17-11": "Pesca a mosca",
    "IAB17-12": "Calcio",
    "IAB17-13": "Pesca d'acqua dolce",
    "IAB17-14": "Selvaggina e pesce",
    "IAB17-15": "Golf",
    "IAB17-16": "Corse di cavalli",
    "IAB17-17": "Cavalli",
    "IAB17-18": "Caccia/Tiro",
    "IAB17-19": "Pattinaggio in linea",
    "IAB17-2": "Baseball",
    "IAB17-20": "Arti Marziali",
    "IAB17-21": "Mountain bike",
    "IAB17-22": "Gara NASCAR",
    "IAB17-23": "Olimpiadi",
    "IAB17-24": "Paintball",
    "IAB17-25": "Potenza e motocicli",
    "IAB17-26": "Basket professionista",
    "IAB17-27": "Hockey su ghiaccio professionista",
    "IAB17-28": "Rodeo",
    "IAB17-29": "Rugby",
    "IAB17-3": "Andare in bicicletta",
    "IAB17-30": "Correre/fare jogging",
    "IAB17-31": "Vela",
    "IAB17-32": "Pesca in acqua salata",
    "IAB17-33": "Immersioni subacquee",
    "IAB17-34": "Skateboard",
    "IAB17-35": "Sci",
    "IAB17-36": "Snowboard",
    "IAB17-37": "Surf/Bodyboard",
    "IAB17-38": "Nuoto",
    "IAB17-39": "Ping-pong/Ping-Pong",
    "IAB17-4": "Culturismo",
    "IAB17-40": "Tennis",
    "IAB17-41": "Pallavolo",
    "IAB17-42": "Camminare",
    "IAB17-43": "Sci nautico/Wakeboard",
    "IAB17-44": "Calcio mondiale",
    "IAB17-5": "Boxe",
    "IAB17-6": "Canoa/Kayak",
    "IAB17-7": "Cheerleader",
    "IAB17-8": "Arrampicata",
    "IAB17-9": "Grillo",
    "IAB18": "Stile e moda",
    "IAB18-1": "Bellezza",
    "IAB18-2": "Arte del corpo",
    "IAB18-3": "Moda",
    "IAB18-4": "Gioielli",
    "IAB18-5": "Abbigliamento",
    "IAB18-6": "Accessori",
    "IAB19": "Tecnologia e informatica",
    "IAB19-1": "Grafica 3D",
    "IAB19-10": "Recensioni di computer",
    "IAB19-11": "Centri dati",
    "IAB19-12": "Database",
    "IAB19-13": "Pubblicazione desktop",
    "IAB19-14": "Video sul desktop",
    "IAB19-15": "E-mail",
    "IAB19-16": "Software di grafica",
    "IAB19-17": "HomeVideo/DVD",
    "IAB19-18": "Tecnologia Internet",
    "IAB19-19": "Giava",
    "IAB19-2": "Animazione",
    "IAB19-20": "JavaScript",
    "IAB19-21": "Supporto Mac",
    "IAB19-22": "MP3/MIDI",
    "IAB19-23": "Conferenza in rete",
    "IAB19-24": "Rete per principianti",
    "IAB19-25": "Sicurezza della rete",
    "IAB19-26": "Palmari/PDA",
    "IAB19-27": "Supporto PC",
    "IAB19-28": "Portatile",
    "IAB19-29": "Intrattenimento",
    "IAB19-3": "Software antivirus",
    "IAB19-30": "Shareware/gratuito",
    "IAB19-31": "Unix",
    "IAB19-32": "Visual Basic",
    "IAB19-33": "ClipArt Web",
    "IAB19-34": "Progettazione Web/HTML",
    "IAB19-35": "Ricerca sul Web",
    "IAB19-36": "Finestre",
    "IAB19-4": "C/C++",
    "IAB19-5": "Fotocamere e videocamere",
    "IAB19-6": "Telefoni cellulari",
    "IAB19-7": "Certificazione informatica",
    "IAB19-8": "Reti informatiche",
    "IAB19-9": "Periferiche per computer",
    "IAB2": "Automobilistico",
    "IAB2-1": "Ricambi auto",
    "IAB2-10": "Veicolo elettrico",
    "IAB2-11": "Hatchback",
    "IAB2-12": "Ibrido",
    "IAB2-13": "Lusso",
    "IAB2-14": "MiniVan",
    "IAB2-15": "Motociclette",
    "IAB2-16": "Veicoli fuoristrada",
    "IAB2-17": "Veicoli ad alte prestazioni",
    "IAB2-18": "Ritiro",
    "IAB2-19": "Assistenza stradale",
    "IAB2-2": "Riparazione auto",
    "IAB2-20": "Berlina",
    "IAB2-21": "Camion e accessori",
    "IAB2-22": "Auto d'epoca",
    "IAB2-23": "Carro",
    "IAB2-3": "Comprare/vendere automobili",
    "IAB2-4": "Cultura automobilistica",
    "IAB2-5": "Usato certificato",
    "IAB2-6": "Convertibile",
    "IAB2-7": "Coupé",
    "IAB2-8": "Incrocio",
    "IAB2-9": "Diesel",
    "IAB20": "Viaggio",
    "IAB20-1": "Viaggi avventurosi",
    "IAB20-10": "Canada",
    "IAB20-11": "Caraibi",
    "IAB20-12": "Crociere",
    "IAB20-13": "Europa orientale",
    "IAB20-14": "Europa",
    "IAB20-15": "Francia",
    "IAB20-16": "Grecia",
    "IAB20-17": "Viaggi di nozze/fughe",
    "IAB20-18": "Alberghi",
    "IAB20-19": "Italia",
    "IAB20-2": "Africa",
    "IAB20-20": "Giappone",
    "IAB20-21": "Messico e America Centrale",
    "IAB20-22": "Parchi nazionali",
    "IAB20-23": "Sud America",
    "IAB20-24": "Terme",
    "IAB20-25": "Parchi a tema",
    "IAB20-26": "Viaggiare con i bambini",
    "IAB20-27": "Regno Unito",
    "IAB20-3": "Viaggio aereo",
    "IAB20-4": "Australia e Nuova Zelanda",
    "IAB20-5": "Bed & Breakfast",
    "IAB20-6": "Viaggio economico",
    "IAB20-7": "Viaggi d'affari",
    "IAB20-8": "Per impostazione locale statunitense",
    "IAB20-9": "Campeggio",
    "IAB21": "Immobiliare",
    "IAB21-1": "Appartamenti",
    "IAB21-2": "Architetti",
    "IAB21-3": "Comprare/vendere case",
    "IAB22": "Fare acquisti",
    "IAB22-1": "Concorsi e omaggi",
    "IAB22-2": "Coupon",
    "IAB22-3": "Confronto",
    "IAB22-4": "Motori",
    "IAB23": "Religione e spiritualità",
    "IAB23-1": "Religioni alternative",
    "IAB23-10": "Pagano/Wiccan",
    "IAB23-2": "Ateismo/Agnosticismo",
    "IAB23-3": "Buddismo",
    "IAB23-4": "Cattolicesimo",
    "IAB23-5": "Cristianesimo",
    "IAB23-6": "Induismo",
    "IAB23-7": "Islam",
    "IAB23-8": "Ebraismo",
    "IAB23-9": "Santi degli Ultimi Giorni",
    "IAB24": "Senza categoria",
    "IAB25": "Contenuti non standard",
    "IAB25-1": "UGC non moderati",
    "IAB25-2": "Violenza estrema, grafica/esplicita",
    "IAB25-3": "Pornografia",
    "IAB25-4": "Contenuto profano",
    "IAB25-5": "Contenuto di odio",
    "IAB25-6": "In costruzione",
    "IAB25-7": "Incentivato",
    "IAB26": "Contenuti illegali",
    "IAB26-1": "Contenuti illegali",
    "IAB26-2": "Warez",
    "IAB26-3": "Spyware/Malware",
    "IAB26-4": "Violazione del diritto d'autore",
    "IAB3": "Affari",
    "IAB3-1": "Pubblicità",
    "IAB3-10": "Logistica",
    "IAB3-11": "Marketing",
    "IAB3-12": "Metalli",
    "IAB3-2": "Agricoltura",
    "IAB3-3": "Biotecnologico/Biomedico",
    "IAB3-4": "Software aziendale",
    "IAB3-5": "Costruzione",
    "IAB3-6": "Silvicoltura",
    "IAB3-7": "Governo",
    "IAB3-8": "Soluzioni verdi",
    "IAB3-9": "Risorse umane",
    "IAB4": "Carriere",
    "IAB4-1": "Pianificazione della carriera",
    "IAB4-10": "Militari statunitensi",
    "IAB4-11": "Consigli di carriera",
    "IAB4-2": "Collegio",
    "IAB4-3": "Aiuto finanziario",
    "IAB4-4": "Fiere del lavoro",
    "IAB4-5": "Ricerca di lavoro",
    "IAB4-6": "Riprendi la scrittura/consulenza",
    "IAB4-7": "Assistenza infermieristica",
    "IAB4-8": "Borse di studio",
    "IAB4-9": "Telelavoro",
    "IAB5": "Istruzione",
    "IAB5-1": "7-12 Istruzione",
    "IAB5-10": "Educazione domiciliare",
    "IAB5-11": "Suggerimenti per i compiti/studio",
    "IAB5-12": "Educatori K-6",
    "IAB5-13": "Scuola privata",
    "IAB5-14": "Educazione speciale",
    "IAB5-15": "Studiare Economia",
    "IAB5-2": "Educazione degli adulti",
    "IAB5-3": "Storia dell'arte",
    "IAB5-4": "Amministrazione universitaria",
    "IAB5-5": "Vita universitaria",
    "IAB5-6": "Apprendimento a distanza",
    "IAB5-7": "Inglese come seconda lingua",
    "IAB5-8": "Apprendimento delle lingue",
    "IAB5-9": "Scuola di specializzazione",
    "IAB6": "Famiglia e genitorialità",
    "IAB6-1": "Adozione",
    "IAB6-2": "Neonati e bambini piccoli",
    "IAB6-3": "Asilo nido/scuola materna",
    "IAB6-4": "Internet familiare",
    "IAB6-5": "Genitorialità - Bambini K-6",
    "IAB6-6": "Genitori adolescenti",
    "IAB6-7": "Gravidanza",
    "IAB6-8": "Bambini con bisogni speciali",
    "IAB6-9": "Assistenza agli anziani",
    "IAB7": "Salute e forma fisica",
    "IAB7-1": "Esercizio",
    "IAB7-10": "Tumore al cervello",
    "IAB7-11": "Cancro",
    "IAB7-12": "Colesterolo",
    "IAB7-13": "Sindrome da stanchezza cronica",
    "IAB7-14": "Dolore cronico",
    "IAB7-15": "Raffreddore e influenza",
    "IAB7-16": "Sordità",
    "IAB7-17": "Cure dentistiche",
    "IAB7-18": "Depressione",
    "IAB7-19": "Dermatologia",
    "IAB7-2": "A.D.D.",
    "IAB7-20": "Diabete",
    "IAB7-21": "Epilessia",
    "IAB7-22": "GERD/reflusso acido",
    "IAB7-23": "Mal di testa/emicranie",
    "IAB7-24": "Malattia cardiaca",
    "IAB7-25": "Erbe per la salute",
    "IAB7-26": "Guarigione olistica",
    "IAB7-27": "IBS/morbo di Crohn",
    "IAB7-28": "Supporto per incesto/abuso",
    "IAB7-29": "Incontinenza",
    "IAB7-3": "AIDS/HIV",
    "IAB7-30": "Infertilità",
    "IAB7-31": "Salute dell'uomo",
    "IAB7-32": "Nutrizione",
    "IAB7-33": "Ortopedia",
    "IAB7-34": "Disturbi di panico/ansia",
    "IAB7-35": "Pediatria",
    "IAB7-36": "Terapia fisica",
    "IAB7-37": "Psicologia/Psichiatria",
    "IAB7-38": "Salute degli anziani",
    "IAB7-39": "Sessualità",
    "IAB7-4": "Allergie",
    "IAB7-40": "Disturbi del sonno",
    "IAB7-41": "Smettere di fumare",
    "IAB7-42": "Abuso di sostanze",
    "IAB7-43": "Malattia della tiroide",
    "IAB7-44": "Perdita di peso",
    "IAB7-45": "Salute delle donne",
    "IAB7-5": "Medicina alternativa",
    "IAB7-6": "Artrite",
    "IAB7-7": "Asma",
    "IAB7-8": "Autismo/PDD",
    "IAB7-9": "Disturbo bipolare",
    "IAB8": "Cibo e bevande",
    "IAB8-1": "Cucina americana",
    "IAB8-10": "Allergie alimentari",
    "IAB8-11": "Cucina francese",
    "IAB8-12": "Cucina salutare/a basso contenuto di grassi",
    "IAB8-13": "Cucina Italiana",
    "IAB8-14": "Cucina giapponese",
    "IAB8-15": "Cucina messicana",
    "IAB8-16": "Vegano",
    "IAB8-17": "Vegetariano",
    "IAB8-18": "Vino",
    "IAB8-2": "Barbecue e grigliate",
    "IAB8-3": "Cajun/creolo",
    "IAB8-4": "Cucina cinese",
    "IAB8-5": "Cocktail/Birra",
    "IAB8-6": "Caffè/Tè",
    "IAB8-7": "Specifico per la cucina",
    "IAB8-8": "Dessert e prodotti da forno",
    "IAB8-9": "Mangiare fuori",
    "IAB9": "Hobby e interessi",
    "IAB9-1": "Arte/Tecnologia",
    "IAB9-10": "Collezionare",
    "IAB9-11": "Fumetti",
    "IAB9-12": "Disegno/schizzo",
    "IAB9-13": "Scrittura freelance",
    "IAB9-14": "Genealogia",
    "IAB9-15": "Essere pubblicati",
    "IAB9-16": "Chitarra",
    "IAB9-17": "Registrazione domestica",
    "IAB9-18": "Investitori e Brevetti",
    "IAB9-19": "Creazione di gioielli",
    "IAB9-2": "Arti e mestieri",
    "IAB9-20": "Magia e illusione",
    "IAB9-21": "Ricamo",
    "IAB9-22": "Pittura",
    "IAB9-23": "Fotografia",
    "IAB9-24": "Radio",
    "IAB9-25": "Giochi di ruolo",
    "IAB9-26": "Fantascienza e fantasia",
    "IAB9-27": "Scrapbooking",
    "IAB9-28": "Sceneggiatura",
    "IAB9-29": "Francobolli e monete",
    "IAB9-3": "Perline",
    "IAB9-30": "Videogiochi e giochi per computer",
    "IAB9-31": "Lavorazione del legno",
    "IAB9-4": "Osservazione degli uccelli",
    "IAB9-5": "Giochi da tavolo/puzzle",
    "IAB9-6": "Produzione di candele e sapone",
    "IAB9-7": "Giochi di carte",
    "IAB9-8": "Scacchi",
    "IAB9-9": "Sigari"
  },
  "layout": {
    "logout": "Esci",
    "navigation": {
      "open": "Apri la navigazione"
    },
    "notifications": "Notifiche",
    "profile": "Il mio profilo",
    "company": "La mia azienda",
    "theme": {
      "label": "Tema",
      "light": "Chiaro",
      "dark": "Scuro",
      "system": "Sistema"
    },
    "sidebar": {
      "close": "Chiudi menu",
      "documentation": "Documentazione",
      "feed": "Feed",
      "hideArchived": "Nascondi archiviati",
      "open": "Apri menu",
      "showArchived": "Mostra archiviati",
      "seeCompany": "Vai all'azienda",
      "advertiser": {
        "createAdgroup": "Crea gruppo di annunci",
        "createCampaign": "Crea campagna",
        "title": "Campagne e gruppi di annunci"
      },
      "publisher": {
        "createPosition": "Crea posizione",
        "createWebsite": "Crea sito web",
        "title": "Siti Web e posizioni"
      }
    },
    "newFrontVersion": {
      "title": "Benvenuti nella nuova versione di Powerspace",
      "oldUrlWarning": "Sei arrivato qui perché probabilmente hai utilizzato un segnalibro della vecchia versione. È necessario salvare nuovamente il segnalibro da questa nuova versione.",
      "loginNewVersion": "Scopri la nuova versione"
    },
    "documentation": "Documentazione",
    "feed": "Feed",
    "hideArchived": "Nascondi archiviati",
    "showArchived": "Mostra archiviati",
    "seeCompany": "Vai all'azienda"
  },
  "login": {
    "errors": {
      "credentialsError": "Errore durante il recupero dei dati per l'accesso:",
      "invalidEmail": "E-mail non valida"
    },
    "form": {
      "continue": "Continua",
      "orSeparator": "Oppure",
      "passwordRecovery": "Hai dimenticato la password?",
      "rememberMe": "Ricordati di me"
    },
    "title": "Benvenuto"
  },
  "position": {
    "create": {
      "passbackStep": "Passaggio di ritorno",
      "successMessage": "La posizione è stata creata con successo",
      "title": "Crea nuova posizione",
      "websiteStep": {
        "title": "Il sito web della posizione",
        "websiteId": "Seleziona il sito web della nuova posizione"
      }
    },
    "created": "Nuova posizione creata !",
    "updated": "La tua posizione è stata aggiornata!",
    "goToPosition": "Vai a {{positionName}}",
    "preview": {
      "eyebrow": "Anteprima non disponibile",
      "noActiveTemplate": "Anteprima non disponibile: nessun modello attivo",
      "inactive": "Anteprima non disponibile: la posizione è inattiva",
      "archived": "Anteprima non disponibile: la posizione è archiviata"
    },
    "settings": {
      "adPreview": "Anteprima",
      "addTag": {
        "noZoneWarning": "È necessaria almeno una zona per visualizzare le informazioni sui tag annuncio",
        "noAdTemplate": "Nessun modello attivo",
        "bottomMessage": {
          "email": "Questo è il codice della posizione che devi installare nell'HTML della tua newsletter. Consiste in un URL di immagine e un URL di clic per ciascun annuncio (zona). I valori tra \"$\" devono essere sostituiti con le informazioni corrette (non conservare \"$\").",
          "web": "I valori tra \"{}\" devono essere sostituiti con le informazioni corrette (non conservare \"{}\")."
        },
        "copyButton": {
          "copied": "Copiato",
          "copy": "Copia",
          "copyAll": "Copia tutto"
        },
        "optionSwitches": {
          "age": "Età",
          "clearEmail": "Cancella e-mail",
          "gender": "Genere",
          "md5Email": "E-mail MD5",
          "sha256Email": "E-mail SHA256",
          "location": "Posizione",
          "tooltip": {
            "md5Email": "E-mail sottoposta ad hashing con l'algoritmo MD5",
            "sha256Email": "E-mail sottoposta ad hashing con l'algoritmo SHA256",
            "gender": "Genere – Formato: M/F o H/F",
            "age": "Data di nascita — Formato: ISO 8601 (AAAA-MM-GG)",
            "location": "Posizione — ps_z (codice postale) e ps_c (codice paese) — Formato: codice postale numerico e codice paese ISO 3166-1 alpha-2 (ad esempio 75001, FR)"
          }
        },
        "tagCode": {
          "endPageScriptMessage": "Questo è il codice della posizione che devi installare nell'HTML della tua newsletter. Consiste in un URL di immagine e un URL di clic per ciascun annuncio (zona). I valori tra \"$\" devono essere sostituiti con le informazioni corrette (non conservare \"$\")."
        },
        "title": "Tag dell'annuncio",
        "topLeft": {
          "customDomain": "Dominio personalizzato",
          "customDomainStatusInProgress": "Creazione del certificato SSL in corso",
          "customDomainStatusInvalid": "Il certificato SSL non è valido. Chiedi a Powerspace maggiori dettagli.",
          "customDomainStatusInvalidWithFailure": "Il certificato SSL non è valido: {{failureReason}}",
          "customDomainStatusValid": "Il certificato SSL è valido",
          "customDomainStatusTooltip": "SSL: {{sslStatus}}",
          "customDomainStatusTooltipWithFailure": "SSL: {{sslStatus}} - Motivo dell'errore: {{failureReason}}",
          "customDomainInvalidStatus": "La configurazione del dominio personalizzato non è ancora valida",
          "webCSS": "Modello CSS",
          "webHTML": "HTML",
          "webIframe": "Iframe"
        },
        "zone": "Zona",
        "adTemplateSelection": "Selezione del template",
        "noAdTemplateWithThisFormat": "Nessun template con questo formato",
        "integrationCode": "Codice di integrazione",
        "atLeastBannerOrNative": "È richiesto almeno un template banner o un template nativo",
        "addZone": "Aggiungi una zona",
        "removeZone": "Rimuovi zona"
      },
      "demandSource": {
        "editTitle": "Modifica origini domanda",
        "title": "Fonti della domanda"
      },
      "passBack": {
        "editTitle": "Modifica parametro PassBack",
        "passbackImage": "Immagine di passaggio",
        "passbackLink": "Collegamento di pass-back",
        "title": "Parametro PassBack"
      },
      "summary": {
        "acceptGif": "Accetta Gif",
        "biddingStrategy": "Strategia di offerta",
        "cpmFloor": "Piano CPM",
        "editTitle": "Modifica le impostazioni di posizione",
        "externalRevenueShare": "Quota di entrate esterne",
        "integrationType": "Tipo di integrazione",
        "nbZone": "Numero di zone",
        "revenueShare": "Quota di ricavi",
        "title": "Riepilogo delle impostazioni di posizione",
        "shortCode": "Codice breve"
      }
    },
    "summary": {
      "channelType": "Tipo di canale",
      "editTitle": "Modifica posizione",
      "network": "Rete",
      "positionType": "Tipo",
      "subchannelType": "Posizionamento",
      "title": "Riepilogo della posizione",
      "status": "Stato"
    }
  },
  "search": {
    "adgroup": {
      "allFilter": "Tutti i gruppi di annunci"
    },
    "allIAB": "Tutte le categorie IAB",
    "campaign": {
      "allFilter": "Tutte le campagne"
    },
    "defaultAllFilter": "Tutto",
    "globalSearch": "Ricerca globale",
    "position": {
      "channelType": "Canale",
      "companyName": "Azienda",
      "id": "ID",
      "status": "Stato",
      "marketCode": "Mercato",
      "nameWithWebsite": "Nome della posizione",
      "network": "Rete",
      "resellerName": "Rivenditore",
      "subchannelType": "Posizionamento"
    },
    "resetFilters": "Reimposta i filtri",
    "user": {
      "selectCompany": "Seleziona l'azienda del nuovo utente",
      "allFilter": "Tutti gli utenti"
    },
    "website": {
      "allFilter": "Tutti i siti web"
    }
  },
  "website": {
    "create": "Crea nuovo sito web",
    "created": "Nuovo sito web creato!",
    "updated": "Il tuo sito web è stato aggiornato",
    "name": "Nome del sito",
    "url": "URL del sito",
    "category": "Categoria",
    "market": "Mercato",
    "details": {
      "companyId": "Azienda",
      "iabCodeAndCategory": "Categoria IAB",
      "market": "Mercato",
      "positions": "Posizioni",
      "publisherId": "Azienda",
      "publisherName": "Azienda",
      "resellerName": "Rivenditore",
      "stepperTitle": "Dettagli del sito web",
      "publisherStepTitle": "Editore",
      "url": "URL"
    },
    "edit": {
      "sectionTitle": "Modifica sito web"
    },
    "goToWebsite": "Vai a {{websiteName}}",
    "positionsHelper": "Aggiungi facoltativamente posizioni al nuovo sito. Puoi aggiungerne più di una prima di completare la creazione.",
    "sectionTitle": "Riepilogo del sito web",
    "statusWarning": "Il sito web {{name}} non è attivo.",
    "tabs": {
      "dashboard": "Dashboard",
      "blacklist": "Lista nera"
    }
  },
  "stats": {
    "title": "Statistiche",
    "statsPerCampaignFor": "Statistiche per campagna {{iab}}",
    "globalStatsFor": "Statistiche globali {{iab}}",
    "top10AdGroupsFor": "Primi 10 gruppi di annunci {{iab}}",
    "common": {
      "invalidReason": {
        "title": "Motivo",
        "CAMPAIGN_NOT_MATCHING": "La campagna fornita non corrisponde alla campagna prevista {{campaignId}}",
        "ALIAS": "Il lead o l'ordine sono già stati registrati in precedenza",
        "OLD_CLICK": "Il clic è scaduto prima del lead o dell'ordine",
        "UNDEFINED_WON_BID": "Nessuna impressione o clic trovato per il lead o l'ordine",
        "TEST": "Prova",
        "NO_CLICK_FOUND": "Nessun clic trovato per il lead o l'ordine",
        "UNDEFINED_POSITION": "Nessuna posizione trovata per il lead o l'ordine",
        "BLACKLISTED": "L'utente è nella lista nera",
        "EMAIL_BLACKLISTED": "L'e-mail è nella lista nera",
        "BLACKLISTED_PROFILE": "L'utente è nella lista nera"
      }
    },
    "maxDetailsMessage": "Non è possibile visualizzare statistiche dettagliate per più di {{maxMonths}} mesi.",
    "chart": {
      "close": "Chiudi grafico",
      "showFullscreen": "Mostra grafico",
      "title": "Grafico"
    },
    "filter": {
      "datesRange": "Date",
      "Channel": "Tipo di canale",
      "Market": "Mercato",
      "Network": "Rete",
      "DemandSource": "Fonti della domanda",
      "granularity": "Granularità",
      "timeframe": "Periodo",
      "dataTypes": "Tipi di dati",
      "kpi": "KPI",
      "timeframeValues": {
        "today": "Oggi",
        "yesterday": "Ieri",
        "thisDayLastWeek": "Questo giorno la settimana scorsa",
        "last3Days": "Ultimi 3 giorni",
        "last30Days": "Ultimi 30 giorni",
        "last60Days": "Ultimi 60 giorni",
        "thisMonth": "Questo mese",
        "lastMonth": "Il mese scorso",
        "thisQuarter": "Questo trimestre",
        "lastQuarter": "Ultimo trimestre",
        "last3Month": "Ultimi 3 mesi",
        "thisWeek": "Questa settimana",
        "lastWeek": "La settimana scorsa",
        "thisYear": "Quest'anno",
        "lastYear": "L'anno scorso",
        "custom": "personalizzato"
      },
      "kpiSelection_one": "1 KPI selezionato",
      "kpiSelection_other": "{{count}} KPI selezionati",
      "displayValues": "Mostra valori",
      "kpiSelection_many": "{{count}} KPI selezionati"
    },
    "table": {
      "date": "Data",
      "commissions": "Commissioni",
      "rpm": "RPM",
      "displays": "Visualizzazioni",
      "channelType": "Canale",
      "lr": "LR",
      "or": "OR",
      "dailyBudget": "Budget giornaliero"
    },
    "customDisplay": {
      "publisher": {
        "displays": "Visualizzazioni",
        "commissions": "Commissioni",
        "cpc": "CPC",
        "rpm": "RPM",
        "lr": "LR",
        "or": "OR",
        "impression": " Impressioni e visualizzazioni",
        "userEvent": "Clic",
        "costRatio": "CTR",
        "costStats": "RPM, CPM e CPC"
      },
      "advertiser": {
        "impression": "Impressioni",
        "cpc": "CPC",
        "cpl": "CPL",
        "cpo": "CPO",
        "rpm": "RPM",
        "lr": "LR",
        "or": "OR",
        "userEvent": "Clic",
        "costRatio": "CTR",
        "costStats": "CPM e CPC",
        "costs": "Costi",
        "roi": "ROI",
        "adGroups": "Gruppi di annunci",
        "campaigns": "Campagne",
        "analytics": "Analytics"
      }
    },
    "dataTypes": {
      "devices": "Dispositivi",
      "timeseries": "Serie temporali",
      "campaigns": "Campagne",
      "positions": "Posizioni",
      "resellers": "Fonti della domanda",
      "adTemplates": "Modelli",
      "websitesAndPositions": "Siti web e posizioni",
      "advertisers": "Inserzionisti",
      "adcopies": "Creatività",
      "adgroups": "Gruppi di annunci",
      "publishers": "Editori",
      "zones": "Zone"
    },
    "powerspace": {
      "budgets": {
        "revenue": "Entrate",
        "dailyBudget": "Budget giornaliero",
        "campaigns": "Campagne",
        "adGroups": "Gruppi di annunci",
        "cpc": "CPC",
        "cpm": "CPM"
      }
    },
    "granularity": {
      "Hour": "all'ora",
      "Day": "al giorno",
      "Week": "a settimana",
      "Month": "al mese",
      "Year": "all'anno"
    }
  },
  "advertiser": {
    "settings": {
      "gestion": "Modalità di gestione dell'inserzionista",
      "subType": "Tipo di inserzionista",
      "unknownTrafficRate": "Tasso di traffico sconosciuto consentito",
      "unknownTrafficRateDescription": "La percentuale di traffico sconosciuto consentita è la percentuale massima di clic o lead che possono essere considerati validi provenienti da una fonte sconosciuta.",
      "copperCompany": "Azienda Copper",
      "unlinkCopperCompany": "Rimuovi collegamento azienda Copper",
      "unlinkAgency": "Rimuovi collegamento agenzia"
    }
  },
  "agency": {
    "settings": {
      "copperCompany": "Azienda Copper",
      "unlinkCopperCompany": "Rimuovi collegamento azienda Copper"
    }
  },
  "tradingDesk": {
    "sectionTitle": "Trading Desk",
    "settings": {
      "seats": "Sedili",
      "dsp": "sp",
      "seat": "sedile"
    }
  },
  "programmaticCampaign": {
    "sectionTitle": "Campagna programmatica",
    "statusWarning": "La campagna programmatica {{name}} è stata interrotta."
  },
  "report": {
    "autoReload": {
      "5m": "5 minuti",
      "10m": "10 minuti",
      "20m": "20 minuti",
      "30m": "30 minuti"
    }
  },
  "activity": {
    "autoReload": {
      "30s": "30 secondi",
      "1m": "1 minuto",
      "5m": "5 minuti",
      "pageOneOnly": "La ricarica automatica è attiva solo sulla pagina 1"
    },
    "refresh": "Aggiorna",
    "todayTitle": "Oggi ({{date}})",
    "yesterdayTitle": "Ieri ({{date}})",
    "earlierTitle": "In precedenza",
    "feed": {
      "userNotFound": "Utente non trovato",
      "propertyOfEntity": "proprietà {{property}} di",
      "fromOldValueToNewValue": "da {{oldValue}} a {{newValue}}",
      "oldToNew": "{{oldValue}} → {{newValue}}",
      "changed": "Cambiato",
      "seeAllChanges": "Vedi tutto",
      "showAllChanges": "Mostra tutte le modifiche",
      "showLimitedChanges": "Mostra meno modifiche",
      "status": "stato",
      "of": "di",
      "from": "da",
      "fromRestrictionListOf": "dalla lista di restrizione di",
      "fromExclusionPresetOf": "dal preset di esclusione",
      "to": "a",
      "toRestrictionListOf": "alla lista di restrizione di",
      "toExclusionPresetOf": "al preset di esclusione",
      "created": "Creato",
      "updated": "Aggiornato",
      "invited": "Invitato",
      "withId": "con id",
      "toJoinCompany": "per partecipare a {{companyName}}",
      "doneAutomaticallyByPlatform": "Eseguito automaticamente dalla piattaforma",
      "platform": "Piattaforma",
      "userPasswordUpdatedBeforeUser": "La password di",
      "userPasswordUpdatedAfterUser": "è stata modificata",
      "geoTargetingChanged": "Il geotargeting è stato modificato",
      "adTemplateNativeContentUpdatedBeforeTemplate": "il contenuto del template",
      "properties": {
        "acceptEditorial": "Accetta editoriale",
        "acceptGif": "Accetta GIF",
        "acceptPromotional": "Accetta promozionale",
        "accessType": "Tipo di accesso",
        "accountingId": "ID contabile",
        "accountManagerId": "Account manager",
        "active": "Attivo",
        "addressLine1": "Indirizzo riga 1",
        "adgroupDirectory": "Restrizione di diffusione",
        "adjustment": "Regolazione",
        "advertiserName": "Nome dell'inserzionista",
        "agencyId": "Agenzia",
        "ageRange": "Fascia d'età",
        "archived": "Archiviato",
        "autoSegments": "Auto-segmenti",
        "backgroundColor": "Colore di sfondo",
        "bankName": "Nome della banca",
        "biddingStrategy": "Strategia di offerta",
        "budget": "Budget",
        "budgetCapping": "Plafond di budget",
        "budgetCappingType": "Tipo di plafond di budget",
        "budgetPlan": "Modifica di budget pianificata",
        "callToAction": "Invito all'azione",
        "channelEmail": "E-mail",
        "channelType": "Tipo di canale",
        "channelWeb": "Web",
        "cities": "Città",
        "city": "Città",
        "comments": "Commenti",
        "company": "Azienda",
        "campaign": "Campagna",
        "iabCategory": "Categoria IAB",
        "contactEmail": "Email di contatto",
        "content": "Contenuto",
        "conversionClickAge": "Età del clic di conversione",
        "cost": "Costo",
        "costModel": "Modello di costo",
        "costType": "Tipo",
        "costValue": "Costo",
        "countries": "Paesi",
        "countryBlacklistRedirectUrl": "URL reindirizzamento blacklist paesi",
        "countryId": "Paese",
        "cpc": "CPC",
        "cpm": "CPM",
        "cpmFloor": "Piano CPM",
        "css": "CSS",
        "cssSelector": "Selettore CSS",
        "cssSelectorPosition": "Posizione selettore CSS",
        "currency": "Valuta",
        "dailyBudget": "Budget giornaliero",
        "dailyBudgetType": "Tipo di budget giornaliero",
        "dayWeek": "Giorno della settimana",
        "dealId": "Deal ID",
        "defaultCpc": "CPC predefinito",
        "demandSources": "Fonti della domanda",
        "departements": "Dipartimenti",
        "description": "Descrizione",
        "deviceExclusive": "Esclusivo dispositivo",
        "deviceType": "Tipo di dispositivo",
        "directoryPositionIds": "Posizioni directory",
        "directoryPresetIds": "Preset di restrizione di diffusione",
        "directoryWebsiteIds": "Siti web directory",
        "email": "Email",
        "endDate": "Data di fine",
        "externalRevenueShare": "Quota di entrate esterne",
        "fax": "Fax",
        "firstName": "Nome",
        "forceRedirectUrl": "Reindirizzamento dell'URL",
        "format": "Formato",
        "gender": "Genere",
        "genericName": "Nome generico",
        "geoExclusive": "Esclusivo geografico",
        "geoTargeting": "Targeting geografico",
        "geoTargetingType": "Tipo di targeting geografico",
        "gestion": "Modalità di gestione dell'inserzionista",
        "hourDay": "Ora del giorno",
        "iban": "IBAN",
        "image": "Immagine",
        "integrationType": "Tipo di integrazione",
        "invoicingCompany": "Entità di fatturazione",
        "isActive": "Attivo",
        "isArchived": "Archiviato",
        "js": "JavaScript",
        "kpis": "KPI",
        "label": "Etichetta",
        "landline": "Telefono fisso",
        "language": "Lingua",
        "lastName": "Cognome",
        "market": "Mercato",
        "marketId": "Mercato",
        "masterTemplate": "Template master",
        "mobile": "Mobile",
        "name": "Nome",
        "nbZone": "Numero di zone",
        "network": "Rete",
        "networkExtensions": "Estensioni di rete",
        "numberCampaignExclusions": "Esclusioni di campagne",
        "numberCustomCosts": "Costi personalizzati",
        "numberWebsiteExclusions": "Esclusioni di siti web",
        "osExclusive": "Esclusivo OS",
        "os": "Sistema operativo",
        "osType": "Tipo di OS",
        "passbackImage": "Immagine di passaggio",
        "passbackJs": "Passback JS",
        "passbackLink": "Collegamento di pass-back",
        "password": "Password",
        "paymentTerm": "Termini di pagamento",
        "permissions": {
          "api": "API",
          "web": "Canale web",
          "banner": "Canale banner",
          "adgroupCpm": "Costo CPM",
          "adgroupCpl": "Costo CPL",
          "adgroupExclusions": "Restrizione di diffusione",
          "adgroupCustomcpcs": "Regolazioni offerta",
          "adgroupReportwebsites": "Report per sito web",
          "adgroupUsertargeting": "Targeting demografico",
          "adgroupGeotargeting": "Targeting geografico",
          "adgroupDevicetargeting": "Targeting dispositivo",
          "adgroupTimetargeting": "Targeting ora e giorno",
          "adgroupSegments": "Segmenti CRM",
          "adgroupAutoSegments": "Auto-segmenti",
          "adgroupPriority": "Priorità adgroup",
          "adgroupMonthlyBudgetCapping": "Limite mensile",
          "adgroupOverallBudgetCapping": "Limite complessivo",
          "adgroupOpenBudgetCapping": "Limite aperto",
          "adgroupOpenDailyBudget": "Budget giornaliero aperto",
          "adCopyDates": "Date creative",
          "positionAdvancedsettings": "Impostazioni avanzate posizione",
          "websiteExclusions": "Esclusioni campagne sito web",
          "advertiserDirectoryPresets": "Preset di directory",
          "publisherBlacklistPresets": "Preset di blacklist"
        },
        "phone": "Telefono",
        "positionIds": "Posizione",
        "positionType": "Tipo di posizione",
        "priorityId": "Priorità",
        "profileTagIds": "Tag profilo",
        "rawGeoTargeting": "Targeting geografico",
        "redirectUrl": "URL di reindirizzamento",
        "regions": "Regioni",
        "registrationId": "ID registrazione",
        "revenueShare": "Quota di ricavi",
        "role": "Ruolo",
        "rootDomain": "Dominio root",
        "rules": "Regole",
        "salesManagerId": "Sales manager",
        "secret": "Secret",
        "segmentIds": "Segmenti",
        "slackId": "Slack ID",
        "slug": "Sottodominio aziendale",
        "sspId": "SSP ID",
        "startDate": "Data di inizio",
        "status": "Stato",
        "subchannelType": "Posizionamento",
        "subType": "Sottotipo",
        "swift": "SWIFT/BIC",
        "tags": "Tag",
        "targetUnknownAge": "Età sconosciuta",
        "taxId": "Codice fiscale",
        "template": "Template",
        "title": "Titolo",
        "unknownTrafficRate": "Tasso traffico sconosciuto",
        "url": "URL",
        "userCappingTimeframe": "Periodo di limite utente",
        "userCappingType": "Tipo di limite utente",
        "userCappingValue": "Valore di limite utente",
        "vatId": "Partita IVA",
        "website": "Sito web",
        "websiteIds": "Sito web",
        "websiteName": "Nome del sito web",
        "weight": "Peso di diffusione",
        "zipCode": "CAP",
        "zones": "Zone",
        "zoneTemplate": "Template zona"
      },
      "deleted": "Eliminato",
      "added": "Aggiunto",
      "removed": "Rimosso",
      "addedOnZoneTheTemplate": "sulla zona {{zone}} il template",
      "removedFromZoneTheTemplate": "dalla zona {{zone}} il template",
      "valueToPropertyOfEntity": "{{value}} alla proprietà {{property}} di",
      "valueFromPropertyOfEntity": "{{value}} dalla proprietà {{property}} di"
    }
  },
  "serverError": {
    "Wrong credentials": "E-mail o password non valide.",
    "ONLY_ADTEMPLATE_ERROR": "Impossibile disabilitare l'unico template attivo per questa posizione."
  },
  "templateEditor": {
    "createMobileVersion": "Sei sicuro di voler creare una versione mobile di questo template annuncio?",
    "control": {
      "addElement": "Aggiungi elementi",
      "addShape": "Aggiungi {{name}}",
      "addPlaceholderCustomText": "Aggiungi il testo \"{{name}}\".",
      "addImage": "Aggiungi segnaposto immagine con rapporto {{ratio}}",
      "backgroundColor": "Colore di sfondo",
      "background": "Sfondo",
      "borderRadius": "Raggio",
      "changeBackgroundColor": "Cambia il colore dello sfondo",
      "fontWeight": "Grassetto",
      "font": "Carattere",
      "fontStyle": "Corsivo",
      "underline": "Sottolineare",
      "upperCase": "attiva/disattiva le maiuscole",
      "width": "Larghezza",
      "height": "Altezza",
      "fontSize": "Dimensione carattere",
      "textColor": "Colore del testo",
      "left": "Da sinistra",
      "top": "Dall'alto",
      "transparentBackground": "Sfondo trasparente",
      "text": "Testo",
      "imageplaceholder": "segnaposto dell'immagine",
      "imageSizeLimit": "L'immagine supera le dimensioni massime, verrà ridimensionata per adattarsi a {{width}}x{{height}}.",
      "moveForward": "Portare in primo piano",
      "moveBackward": "Invia in background",
      "align": {
        "left": "Allinea a sinistra",
        "center": "Allinea al centro",
        "right": "Allinea a destra",
        "top": "Allinea in alto",
        "middle": "Allinea al centro",
        "bottom": "Allinea il fondo"
      },
      "templateBackgroundColor": "Colore di sfondo",
      "templateBackgroundImage": "Scegli uno sfondo",
      "newText": "Nuovo testo",
      "placeholderAlreadyExists": "Il placeholder {{placeholder}} esiste già nel template",
      "imageAlreadyExists": "Esiste già un'immagine nel template",
      "removeBackground": "Rimuovi l'immagine di sfondo",
      "settings": "Impostazioni del template",
      "stroke": "Colore del tratto",
      "strokeWidth": "Larghezza del tratto",
      "shape": "Forma",
      "zoom": "Zoom"
    },
    "oneImageMax": "Nel template è consentita una sola immagine",
    "duplicatedPlaceholder": "I segnaposto devono essere univoci",
    "title": "Editor di modelli",
    "preview": {
      "title": "Anteprima del template"
    },
    "unsavedChanged": "Sono presenti modifiche non salvate su questo modello. Sei sicuro di voler passare a {{versionType}}? Tutte le modifiche non salvate andranno perse.",
    "versionType": {
      "main": "Versione principale",
      "mobile": "Versione mobile"
    },
    "importTemplate": "Importa template",
    "importTemplateSuccess": "Il template è stato importato!",
    "chooseTemplate": "Scegli un template",
    "imageSizeWarning": "Per una corretta centratura, la dimensione dell'immagine deve corrispondere alla dimensione del template visualizzato sopra. È ancora possibile salvare l'immagine, ma la centratura potrebbe non essere corretta.",
    "imageOutOfTemplate": "L'immagine principale di questo template presenta parti esterne al template; ciò può produrre annunci tagliati male e un CTR inferiore.",
    "canvasSizeWarning": "Le immagini con larghezza inferiore a 400px potrebbero essere pixelate, per visualizzare correttamente un piccolo template, aumenta la larghezza di questo e fissa la dimensione nel tuo CSS."
  },
  "table": {
    "columns": "Colonne",
    "comparisonFilter": {
      "after": "Dopo",
      "before": "Prima",
      "between": "Tra",
      "end": "Fine",
      "lessThan": "Meno di",
      "lessThanOrEqual": "Minore o uguale a",
      "moreThan": "Più di",
      "moreThanOrEqual": "Più o uguale",
      "operator": "Filtro data",
      "start": "Inizia"
    },
    "emptyValues": "Valori vuoti",
    "filterValue": "Valore del filtro",
    "nonEmptyValues": "Valori non vuoti"
  },
  "resetPassword": {
    "enterNewPassword": "Inserisci la tua nuova password",
    "login": "Login",
    "emailSentMessage": "È stata inviata un'e-mail a <strong>{{email}}</strong>. Clicca sul link all'interno per creare una nuova password. Se non ricevi questa email, controlla lo spam",
    "newPassword": "Nuova password",
    "resetSuccess": "La tua password è stata reimpostata con successo. Ora puoi accedere con la tua nuova password",
    "requestInstruction": "Inserisci la tua email qui sotto e riceverai le istruzioni per reimpostare la password",
    "returnToLogin": "Torna al login",
    "requestResetPassword": "Richiedi la reimpostazione della password",
    "resetPasswordSubmit": "Reimposta password",
    "title": "Hai dimenticato la password?",
    "serverError": {
      "tokenExpired": "Siamo spiacenti, questo collegamento per la reimpostazione della password è scaduto. Richiedi un nuovo collegamento per la reimpostazione della password e riprova."
    }
  },
  "invitation": {
    "acceptInvitation": "Accetta l'invito",
    "title": "Creazione dell'account",
    "contactDetails": "i tuoi dati di contatto",
    "password": "Password",
    "acceptInviteSuccess": "Il tuo account è stato creato con successo. Ora puoi accedere con la tua email e password",
    "goToLogin": "Vai alla pagina di accesso",
    "serverError": {
      "invalidToken": "Siamo spiacenti, questo link di invito non è valido. Richiedi un nuovo collegamento di invito e riprova."
    },
    "AcceptInvitation": "Accetta l'invito"
  },
  "ErrorBoundaryUIFallback": {
    "eyebrow": "Ops!",
    "somethingWentWrong": "Qualcosa di imprevisto è successo.",
    "apologizeInconvenience": "Ci scusiamo per l'inconveniente. Aggiornare la pagina spesso risolve il problema.",
    "refreshPage": "Aggiorna pagina"
  },
  "NotFoundPage": {
    "eyebrow": "404",
    "title": "Non riusciamo a trovare questa pagina.",
    "description": "Il link potrebbe essere errato o la pagina potrebbe essere stata spostata. Ti riportiamo in carreggiata.",
    "backToHome": "Torna alla dashboard",
    "backToLogin": "Torna al login"
  },
  "adTest": {
    "settings": {
      "zoom": "Dimensione anteprima"
    }
  },
  "simulation": {
    "title": "Simulazione reach",
    "description": "Configura mercato, network, targeting ed eventualmente preset di restrizione broadcast per visualizzare il reach stimato senza salvare.",
    "disclaimer": "Le modifiche in questa pagina non vengono salvate. Usala per esplorare l'impatto sul reach prima di aggiornare un ad group.",
    "directory": {
      "title": "Restrizione di diffusione"
    },
    "reach": {
      "info": "Questa stima non include geotargeting e segmenti."
    },
    "errors": {
      "market": "Impossibile caricare i mercati per la simulazione."
    }
  },
  "home": {
    "tabs": {
      "powerspace": "Powerspace",
      "activityfeed": "Feed attività",
      "adTest": "Anteprima",
      "reports": "Report",
      "companies": "Aziende",
      "adgroups": "Gruppi di annunci",
      "websites": "Siti web",
      "positions": "Posizioni",
      "users": "Utenti"
    }
  },
  "impersonation": {
    "connectAs": "Connettersi come {{firstName}} {{lastName}}",
    "confirm": "Connettersi come {{firstName}} {{lastName}}? Navigherai nell'app in sola lettura come questo utente.",
    "banner": "Modalità viewer: sei connesso come {{firstName}} {{lastName}} ({{email}}).",
    "quit": "Esci dall'impersonation",
    "errors": {
      "notAuthenticated": "Devi essere autenticato per impersonare un utente.",
      "startFailed": "Impossibile avviare l'impersonation."
    }
  },
  "directoryPresets": {
    "createTitle": "Crea lista di restrizione",
    "editTitle": "Modifica lista di restrizione",
    "description": "Crea preset di restrizione di diffusione per riutilizzare le stesse restrizioni di siti web e posizioni nei tuoi gruppi di annunci.",
    "created": "Preset di restrizione creato",
    "saved": "Preset di restrizione salvato",
    "deleted": "Preset di restrizione eliminato",
    "deleteConfirm": "Eliminare la lista di restrizione {{name}}? Verrà rimossa anche da tutti gli ad group che l'hanno selezionata.",
    "addTitle": "Aggiungi siti web",
    "duplicateName": "Questo nome è già usato da un'altra lista di restrizione",
    "view": "Visualizza",
    "viewTitle": "Lista di restrizione",
    "unassign": "Rimuovi assegnazione"
  },
  "billing": {
    "actionButtons": {
      "download": "Scarica",
      "edit": "Modifica",
      "validate": "Convalida",
      "validateAll": "Convalida le fatture selezionate",
      "recordPayment": "Registra il pagamento",
      "downloadInvoices": "Scarica le fatture selezionate"
    },
    "editInvoice": {
      "comment": "Commento",
      "publisher": "Editore",
      "billedTo": "Fatturato a",
      "invoiceNb": "Fattura n",
      "payment": "Pagamento",
      "description": "Descrizione/commissioni pubblicitarie",
      "updated": "Fattura aggiornata",
      "totalExcludingTaxes": "Totale parziale",
      "totalIncludingTaxes": "Totale comprensivo di tasse",
      "title": "Modifica fattura",
      "vat": "IVA"
    },
    "confirmValidation": "Sei sicuro di voler modificare lo stato delle fatture in VALIDATO? I contatti interessati verranno avvisati e sarà condivisa una copia della/e fattura/e.",
    "invoicesAlreadyGenerated": "Tutte le fatture per questo periodo sono già state generate",
    "downloadError": "Si è verificato un errore durante il download della fattura. Riprova o contatta l'assistenza.",
    "downloadInvoice": "Scarica fattura",
    "generateInvoices": "Genera fatture",
    "generatedSuccess": "Fattura generata con successo",
    "minAmount": "Importo minimo",
    "paidInvoice": {
      "title": "Registra il pagamento",
      "saved": "Il pagamento è stato registrato",
      "paidWarning": "Sei sicuro di voler modificare lo stato della fattura in PAGATO? I contatti interessati verranno avvisati e sarà condivisa una copia della fattura. La fattura verrà permanentemente contrassegnata come pagata e non sarà possibile alcuna altra modifica."
    },
    "Paid": "Pagato",
    "Pending": "In attesa",
    "Validated": "Convalidato",
    "reference": "Riferimento",
    "period": "Periodo",
    "publisherName": "Editore",
    "advertiserName": "Inserzionista",
    "amount": "Importo",
    "tax": "Tassa",
    "total": "Importo totale",
    "date": "Data",
    "dueDate": "Data di scadenza",
    "previewInvoice": "Anteprima della fattura",
    "summary": "Riepilogo fatture",
    "selectedCount_one": "Fattura {{count}} selezionata",
    "selectedCount_other": "{{count}} fatture selezionate",
    "validated": "La fattura è stata convalidata"
  },
  "publisher": {
    "analyze": {
      "title": "Analizzare",
      "privateStatsMessage": "Queste statistiche sono private e visibili solo a Powerspace. Non condividerle con i tuoi clienti.",
      "populationStats": {
        "title": "Popolazione",
        "os": "sistema operativo",
        "deviceType": "Tipo di dispositivo",
        "ageRange": "Fascia d'età",
        "gender": "Genere"
      }
    },
    "blacklist": {
      "title": "Liste nere",
      "advertisers": "Inserzionisti esclusi",
      "advertisersDescription": "Blocca la delivery per gli inserzionisti selezionati.",
      "campaigns": "Campagne escluse",
      "campaignsDescription": "Blocca la delivery per le campagne selezionate.",
      "addAdvertisers": "Aggiungi inserzionisti nella lista nera",
      "addCampaigns": "Aggiungi campagne nella lista nera",
      "addDomains": "Aggiungi domini nella lista nera",
      "addIabCategories": "Aggiungi categorie Iab nella lista nera",
      "newlyAddedAdvertisers": "inserzionisti selezionati",
      "newlyAddedCampaigns": "campagne selezionate",
      "newlyAddedCategories": "iab selezionati",
      "domainSeparators": "I domini devono essere separati da uno spazio o da una virgola",
      "domainPlaceholder": "Digita qui per inserire i domini nella lista nera",
      "iab": "Categorie IAB escluse",
      "iabDescription": "Blocca la delivery sui contenuti corrispondenti alle categorie IAB selezionate.",
      "domains": "Domini esclusi",
      "domainsDescription": "Blocca la delivery sui domini inserzionisti selezionati.",
      "publisherExclusionsTitle": "Esclusioni publisher",
      "publisherExclusionsDescription": "Configura le esclusioni applicate a questo publisher, inclusi i preset assegnati e le esclusioni dirette.",
      "resellerExclusionsTitle": "Esclusioni reseller",
      "resellerExclusionsDescription": "Configura le esclusioni applicate a questo reseller e ereditate dai suoi publisher e siti web.",
      "websiteExclusionsTitle": "Esclusioni del sito web",
      "websiteExclusionsDescription": "Configura le esclusioni applicate a questo sito web, inclusi i preset assegnati e le esclusioni dirette.",
      "publisherExclusionListsTitle": "Preset di esclusione publisher",
      "publisherExclusionListsDescription": "Crea e gestisci preset di esclusione riutilizzabili per questo publisher. Assegnali dalla sezione esclusioni sotto.",
      "resellerExclusionListsTitle": "Preset di esclusione reseller",
      "resellerExclusionListsDescription": "Crea e gestisci preset di esclusione riutilizzabili per questo reseller. Questi preset sono disponibili per tutti i publisher e i siti web di questo reseller. Assegnali dalla sezione esclusioni sotto.",
      "presets": {
        "title": "Preset di esclusione",
        "assignDescription": "Applica preset di esclusione riutilizzabili a questo ambito.",
        "name": "Nome del preset",
        "use": "Usa un preset",
        "createNew": "Crea preset",
        "assigned": "Assegnato",
        "unassign": "Rimuovi",
        "noAvailablePresets": "Nessun preset disponibile da assegnare.",
        "noOwnedPresets": "Nessun preset di proprietà.",
        "noAssignedPresets": "Nessun preset assegnato.",
        "resellerAssignDescription": "I preset assegnati qui si applicano a tutti i publisher e i siti web di questo reseller.",
        "ownedTitle": "Preset posseduti",
        "deleteConfirm": "Eliminare questo preset di esclusione?",
        "createTitle": "Crea preset di esclusione",
        "editTitle": "Modifica preset di esclusione",
        "loadError": "Impossibile caricare il preset di esclusione.",
        "viewTitle": "Preset di esclusione",
        "noExclusions": "Nessuna esclusione in questa categoria.",
        "convertToPreset": "Converti in preset",
        "convertToPresetTitle": "Converti la blacklist in preset",
        "ownerCompany": "Società proprietaria",
        "replaceWithPresetConfirm": "Sostituire la blacklist attuale con il preset {{name}}?",
        "replaceWithPresetApplied": "Preset applicato e blacklist cancellata",
        "duplicateName": "Questo nome è già utilizzato da un altro preset di esclusione",
        "domainsPreservedOnConvert": "Le esclusioni di dominio non possono essere salvate nei preset e rimarranno su questo oggetto.",
        "created": "Preset di esclusione creato",
        "convertToPresetDisabledAssignedPreset": "Un preset è già assegnato. Rimuovi i preset assegnati prima di convertire la blacklist.",
        "convertToPresetDisabledEmpty": "Non ci sono esclusioni inserzionista, campagna o IAB da convertire."
      },
      "filters": {
        "advertiserName": "Nome dell'inserzionista",
        "name": "Nome della campagna",
        "iab": "Categoria IAB"
      },
      "table": {
        "advertiser": {
          "parent": "Genitore",
          "name": "Inserzionista",
          "createdAt": "Data di creazione",
          "actions": "Azioni"
        },
        "campaign": {
          "parent": "Genitore",
          "advertiser": "Inserzionista",
          "name": "Campagna",
          "advertiserDomainName": "Dominio",
          "createdAt": "Data di creazione",
          "actions": "Azioni"
        },
        "parent": "Genitore",
        "iab": "Categoria IAB",
        "domain": "Dominio",
        "createdAt": "Data di creazione",
        "actions": "Azioni"
      }
    }
  },
  "reseller": {
    "assistantRules": {
      "title": "Assistente",
      "table": {
        "key": "Chiave",
        "type": "Tipo"
      },
      "fields": {
        "isActive": "Attivo",
        "importance": "Importanza",
        "config": "Configurazione",
        "configDescription": "Condizioni che devono essere soddisfatte affinché questa regola venga eseguita. Ogni riga è un ambito, un campo, un operatore e un valore. Utilizzare il controllo logico per richiedere tutte le condizioni o una qualsiasi di esse.",
        "recommendedChanges": "Modifiche consigliate",
        "recommendedChangesDescription": "Azioni facoltative suggerite quando la regola corrisponde (ad esempio l'aggiornamento di un campo). Lascia vuoto questo campo se la regola deve basarsi solo sul titolo e sulla descrizione senza modifiche suggerite.",
        "entity": "Entità",
        "message": "Messaggio",
        "key": "Chiave",
        "value": "Valore"
      },
      "modal": {
        "title": "Modifica regola: {{name}}",
        "key": "Chiave della regola: {{key}}",
        "createUserRuleTitle": "Crea regola utente",
        "editUserRule": "Modifica regola utente",
        "editSystemRule": "Modifica regola di sistema",
        "basicInfo": "Informazioni di base",
        "descriptionPlaceholder": "Descrivi cosa fa questa regola e quando dovrebbe attivarsi"
      },
      "actions": {
        "createUserRule": "Crea regola utente"
      },
      "sections": {
        "systemRules": "Regole del sistema",
        "userRules": "Regole utente"
      },
      "errors": {
        "invalidJson": "La configurazione deve essere un JSON valido.",
        "invalidRecommendedChangesJson": "Le modifiche consigliate devono essere un array JSON valido.",
        "invalidJsonObject": "La configurazione deve essere un oggetto JSON valido.",
        "missingRuleKey": "Questa regola non può essere modificata perché manca la chiave.",
        "noSchemaForRuleKey": "Nessuno schema dedicato trovato per questa chiave della regola di sistema. Ritornando all'editor JSON.",
        "emptyConfig": "Nessuna chiave di configurazione disponibile per questa regola.",
        "expectedString": "Il valore deve essere una stringa.",
        "expectedBoolean": "Il valore deve essere booleano.",
        "deleteUserRule": "Impossibile eliminare la regola. Per favore riprova."
      },
      "configFields": {
        "adcopiesForBudget": "Copie pubblicitarie per il budget",
        "maxLifetimeDays": "Durata di un test A/B",
        "weeklyClickThreshold": "Soglia di clic settimanale per un test A/B",
        "minimumAdCopies": "Numero minimo di copie pubblicitarie",
        "minimumBudgetPerAdCopy": "Budget minimo per testo pubblicitario",
        "maximumAdCopies": "Numero massimo di copie dell'annuncio",
        "minimumImpressions": "Impressioni minime",
        "minimumDaysSinceLastAbTest": "Giorni minimi dall'ultimo test A/B",
        "minimumAbTestImpressions": "Impressioni minime del test A/B",
        "maximumImbalanceRatio": "Rapporto massimo di squilibrio",
        "minimumRemainingDays": "Giorni rimanenti minimi",
        "minimumDailyBudget": "Budget giornaliero minimo"
      },
      "systemRuleDescriptions": {
        "AdCopyMaxLifetimeExceeded": "Una o più creatività hanno raggiunto la durata massima.",
        "AdGroupNotEnoughAdCopiesForBudget": "Il gruppo di annunci non dispone di creatività sufficienti per il budget corrente.",
        "AdGroupTooManyAdCopiesForBudget": "Il gruppo di annunci contiene troppe creatività per il budget attuale.",
        "AdGroupAdCopyReadyForNewAbTest": "Il gruppo di annunci ha una creatività pronta per un nuovo test A/B.",
        "AdGroupImbalancedAbTestImpressions": "Il gruppo di annunci presenta impressioni del test A/B sbilanciate.",
        "AdGroupIncreaseDailyBudgetForBudgetCapping": "Il limite del budget giornaliero è troppo basso. Aumenta il budget giornaliero o passa al budget giornaliero automatico."
      },
      "systemRuleConfigKeys": {
        "AdGroupNotEnoughAdCopiesForBudget": {
          "adcopiesForBudget": "Copie pubblicitarie per il budget"
        }
      },
      "conditionEditor": {
        "logic": "Logica",
        "all": "Ogni regola dovrebbe essere valida",
        "any": "Dovrebbe essere valida una sola regola",
        "scope": "Ambito",
        "field": "Campo",
        "operator": "Operatore",
        "action": "Azione",
        "value": "Valore",
        "params": "Param",
        "addCondition": "Aggiungi condizione",
        "compareField": "Confronta campo",
        "compareFieldNeedsPrimary": "Seleziona prima un campo condizione",
        "compareFieldPrimaryUnavailable": "Questo campo non può essere utilizzato per il confronto",
        "compareToField": "Passa al confronto dei campi",
        "compareToValue": "Passa al confronto dei valori"
      },
      "fieldTypeHints": {
        "currency": "Valuta",
        "percent": "Percentuale",
        "count": "Conte",
        "number": "Numero",
        "boolean": "Booleano"
      },
      "paramsFields": {
        "periodDays": "Numero di giorni",
        "skipRecentDays": "Giorni recenti da saltare"
      },
      "operators": {
        "Between": "Tra",
        "Contains": "Contiene",
        "Eq": "Uguale",
        "Falsy": "È falso",
        "Gt": "Maggiore di",
        "Gte": "Maggiore o uguale",
        "In": "Nella lista",
        "Intersects": "Si interseca",
        "IsEmpty": "È vuoto",
        "IsNotEmpty": "Non è vuoto",
        "Lt": "Minore di",
        "Lte": "Minore o uguale",
        "Neq": "Diverso da",
        "NotContains": "Non contiene",
        "Truthy": "È vero",
        "Delete": "Elimina",
        "Replace": "Sostituisci",
        "Update": "Aggiorna"
      },
      "recommendedChangesEditor": {
        "group": "Logica",
        "all": "Ogni regola di modifica consigliata dovrebbe essere valida",
        "any": "Dovrebbe essere valida solo una regola di modifica consigliata",
        "messagePlaceholder": "Descrivi cosa modificare quando viene attivata questa regola (ad esempio \"Aumenta il budget giornaliero a € 50\")",
        "messagePerConditionPlaceholder": "Messaggio facoltativo per questa condizione specifica",
        "noChanges": "Nessuna modifica consigliata ancora. Aggiungi un gruppo per iniziare.",
        "noActions": "Nessuna azione ancora. Fai clic su \"Aggiungi azione\" per definire cosa dovrebbe cambiare.",
        "addGroup": "Aggiungi gruppo di consigli",
        "conditions": "Condizioni",
        "actionsDescription": "Aggiungi una riga per ogni impostazione a cui fa riferimento questo consiglio.",
        "addAction": "Aggiungi azione",
        "howToFixThat": "Perché è necessario e come risolverlo?",
        "doAllNecessary": "Apporta tutte le modifiche necessarie",
        "onlyOneChange": "È possibile effettuare una sola modifica"
      },
      "scopes": {
        "adGroup": "Gruppo di annunci",
        "adCopies": "Creatività",
        "adGroupTargeting": "Targeting per gruppo di annunci"
      },
      "scopeSubCategories": {
        "demographics": "Dati demografici",
        "geoTargeting": "Targeting geografico",
        "deviceOs": "Dispositivo e sistema operativo",
        "timeTargeting": "Targeting temporale",
        "reach": "Copertura",
        "other": "Altro",
        "stats": "Statistiche"
      },
      "scopeFields": {
        "monthlyBudget": "Budget mensile",
        "overallBudget": "Budget complessivo",
        "startDate": "Data di inizio",
        "endDate": "Data di fine",
        "stats.averageDaySpent": "Spesa giornaliera media",
        "stats.yesterdayImpressions": "Impressioni di ieri",
        "stats.yesterdayClicks": "Clic di ieri",
        "stats.yesterdayLeads": "Lead di ieri",
        "stats.yesterdayOrders": "Ordini di ieri",
        "stats.yesterdayCtr": "CTR di ieri",
        "stats.yesterdayLr": "LR di ieri",
        "stats.yesterdayOr": "OR di ieri",
        "stats.averageDailyImpressions": "Impressioni giornaliere medie",
        "stats.averageDailyClicks": "Clic giornalieri medi",
        "stats.averageDailyLeads": "Lead giornalieri medi",
        "stats.averageDailyOrders": "Ordini giornalieri medi",
        "stats.averageDailyCtr": "CTR giornaliero medio",
        "stats.averageDailyLr": "LR medio giornaliero",
        "stats.averageDailyOr": "OR medio giornaliero",
        "cpc": "CPC",
        "cpm": "CPM",
        "cpl": "CPL",
        "cpo": "CPO",
        "userCappingUncapped": "Limite utente non limitato",
        "userCappingImpression": "Impressioni limitate dall'utente",
        "userCappingClick": "Capping utente per clic",
        "status": "Stato",
        "dailyBudgetAuto": "Budget giornaliero automatico",
        "dailyBudgetFixed": "Budget giornaliero fisso",
        "dailyBudgetOpen": "Budget giornaliero aperto",
        "budgetCappingType": "Tipo di limite di budget",
        "dailyBudgetType": "Tipo di budget giornaliero",
        "device.type": "Tipo di dispositivo",
        "os.exclusive": "Sistema operativo esclusivo",
        "os.type": "Tipo di sistema operativo",
        "gender": "Genere",
        "age.range": "Fascia d'età",
        "age.unknown": "Targettizza età sconosciuta",
        "device.exclusive": "Dispositivo esclusivo",
        "time.days": "Giorni",
        "time.hours": "Ore",
        "geoTargeting.geoExclusive": "Esclusivo targeting geografico",
        "geoTargeting.countries": "Paesi con targeting geografico",
        "geoTargeting.geoTargetingType": "Tipo di targeting geografico",
        "geoTargeting.cities": "Città con targeting geografico",
        "geoTargeting.regions": "Regioni con targeting geografico",
        "geoTargeting.departements": "Dipartimenti di targeting geografico",
        "reach.impressions": "Impressioni di copertura",
        "reach.cpc": "CPC di copertura",
        "count": "Conteggio",
        "statuses": "Stati",
        "titles": "Titoli",
        "callToActions": "Invito all'azione"
      },
      "fieldUnits": {
        "Currency": "€",
        "Percent": "%",
        "Count": "#"
      },
      "scopeFieldDescriptions": {
        "monthlyBudget": "Importo massimo che il gruppo di annunci può spendere al mese.",
        "overallBudget": "Limite di budget totale per il gruppo di annunci nel corso della sua durata.",
        "startDate": "Il primo giorno in cui il gruppo di annunci è idoneo alla pubblicazione.",
        "endDate": "L'ultimo giorno in cui il gruppo di annunci è idoneo alla pubblicazione.",
        "stats.averageDaySpent": "Spesa giornaliera media nel periodo delle statistiche selezionato.",
        "stats.yesterdayImpressions": "Impressioni registrate il giorno precedente.",
        "stats.yesterdayClicks": "Clic registrati il ​​giorno precedente.",
        "stats.yesterdayLeads": "Lead registrati il ​​giorno precedente.",
        "stats.yesterdayOrders": "Ordini registrati il ​​giorno precedente.",
        "stats.yesterdayCtr": "Percentuale di clic per il giorno precedente.",
        "stats.yesterdayLr": "Tariffa principale per il giorno precedente.",
        "stats.yesterdayOr": "Tasso di ordine per il giorno precedente.",
        "stats.averageDailyImpressions": "Impressioni medie al giorno.",
        "stats.averageDailyClicks": "Clic medi al giorno.",
        "stats.averageDailyLeads": "Lead medi al giorno.",
        "stats.averageDailyOrders": "Ordini medi al giorno.",
        "stats.averageDailyCtr": "Percentuale di clic media giornaliera.",
        "stats.averageDailyLr": "Tasso medio di lead giornaliero.",
        "stats.averageDailyOr": "Tasso medio giornaliero degli ordini.",
        "cpc": "Costo per clic.",
        "cpm": "Costo per mille impressioni.",
        "cpl": "Costo per lead.",
        "cpo": "Costo per ordine.",
        "userCappingUncapped": "Se il limite di frequenza a livello di utente è disabilitato.",
        "userCappingImpression": "Limite di frequenza utente basato sulle impressioni.",
        "userCappingClick": "Limite di frequenza utente basato sui clic.",
        "status": "Stato del gruppo di annunci.",
        "dailyBudgetAuto": "Budget giornaliero quando si utilizza il pacing automatico.",
        "dailyBudgetFixed": "Budget giornaliero se impostato su un importo fisso.",
        "dailyBudgetOpen": "Budget giornaliero in modalità a tempo indeterminato.",
        "budgetCappingType": "Come la spesa è limitata rispetto al budget.",
        "dailyBudgetType": "Strategia utilizzata per il budget giornaliero.",
        "device.type": "Categoria del dispositivo presa di mira.",
        "os.exclusive": "Se il targeting è esclusivo per una famiglia di sistemi operativi.",
        "os.type": "Famiglia di sistemi operativi presa di mira.",
        "gender": "Targeting demografico di genere.",
        "age.range": "Fascia di età presa di mira.",
        "age.unknown": "Indica se sono inclusi gli utenti di età sconosciuta.",
        "device.exclusive": "Indica se il targeting è esclusivo per un tipo di dispositivo.",
        "time.days": "Giorni della settimana inclusi nella programmazione.",
        "time.hours": "Orari della giornata compresi nella programmazione.",
        "geoTargeting.geoExclusive": "Se il targeting geografico è scelto come target o escluso.",
        "geoTargeting.countries": "Paesi inclusi o esclusi dal targeting.",
        "geoTargeting.geoTargetingType": "Modalità di targeting geografico.",
        "geoTargeting.cities": "Città incluse o escluse dal targeting.",
        "geoTargeting.regions": "Regioni incluse o escluse dal targeting.",
        "geoTargeting.departements": "Dipartimenti inclusi o esclusi nel targeting.",
        "reach.impressions": "Impressioni medie per la popolazione target.",
        "reach.cpc": "CPC medio per la popolazione target.",
        "count": "Numero di creatività.",
        "statuses": "Valori di stato della creatività da abbinare.",
        "titles": "Titoli creativi da abbinare.",
        "callToActions": "Etichette di invito all'azione da abbinare."
      }
    }
  },
  "powerspace": {
    "account": {
      "title": "Contabilità",
      "table": {
        "yesterdayCpm": "Il CPM di ieri",
        "lastModified": "Ultima modifica",
        "remainingTime": "Tempo rimanente",
        "budget": "Budget",
        "current": "Corrente",
        "spentToday": "Speso oggi",
        "recommendation": "Raccomandazione",
        "recommendationsCount_one": "1 raccomandazione",
        "recommendationsCount_other": "Raccomandazioni {{count}}",
        "recommendationsCount_many": "Raccomandazioni {{count}}"
      },
      "warning": {
        "dailyBudgetThreshold": "Il budget giornaliero è superiore a {{threshold}}€",
        "cpmThreshold": "Il CPM è inferiore al CPM medio del rivenditore pari a {{resellerCPM}}€"
      }
    },
    "population": {
      "title": "Raggiungi la popolazione"
    },
    "budgets": {
      "title": "Budget giornalieri",
      "accountFilter": "Account",
      "salesFilter": "Commerciale",
      "dailyRepartition": "Budget giornaliero",
      "revenueRepartition": "Entrate",
      "cpcRepartition": "CPC",
      "cpmRepartition": "CPM",
      "advertiserRepartition": "Inserzionisti",
      "campaignRepartition": "Campagne",
      "dayBudgetRatio": "{{ratio}}% del budget giornaliero",
      "spentOverDailyBudget": "{{spent}} spesi su {{budget}} di budget giornaliero"
    },
    "demandSources": {
      "title": "Fonti della domanda",
      "impressions": "Impressioni",
      "unfilled": "Non riempito",
      "powerspace": "Powerspace",
      "other": "Altri"
    },
    "adProductTiers": {
      "category": "Categoria",
      "adGroupsCount_one": "{{count}} ad group",
      "adGroupsCount_other": "{{count}} ad groups",
      "repartition": {
        "impressions": "Impressioni",
        "clicks": "Clic",
        "costs": "Costi"
      },
      "details": {
        "adGroups": "Gruppi di annunci",
        "ageGender": "Età e genere",
        "age": "Per fascia d'età",
        "gender": "Per genere",
        "ageRepartition": "Impressioni per fascia d'età",
        "genderRepartition": "Impressioni per genere",
        "ageGenderUnavailable": "La ripartizione per età e genere è disponibile solo per le categorie complete di un tier.",
        "websites": "Siti",
        "iabCategories": "Categorie IAB",
        "otherCategories": "Altre categorie"
      },
      "adGroupsCount_many": "{{count}} ad groups"
    },
    "adGroups": {
      "title": "Analisi dei gruppi di annunci",
      "tabs": {
        "iabCategory": "Categoria IAB",
        "iabContent": "Prodotto pubblicitario IAB"
      },
      "iabRepartition": {
        "title": "Ripartizione categorie IAB",
        "revenues": "Ricavi per IAB",
        "otherDetails": "Altro",
        "minor": "Ripartizione categorie IAB"
      },
      "top10AdGroups": "I primi 10 gruppi di annunci",
      "iabTotalStats": "Statistiche totali IAB",
      "globalCampaignStats": "Statistiche della campagna globale",
      "globalIabRevenues": "Ricavi globali IAB"
    },
    "validation": {
      "title": "Validazione creatività",
      "empty": "Nessuna creatività è in attesa di validazione."
    }
  },
  "sentEmail": {
    "verified": "Almeno un'email a questo indirizzo è stata ricevuta",
    "lastEmailError": "L'ultima email a questo indirizzo non è andata a buon fine",
    "emailDoesNotExist": "L'indirizzo del destinatario non esiste",
    "statusPending": "In attesa",
    "statusReceived": "Ricevuta",
    "statusError": "Errore",
    "invoiceSectionTitle": "Email inviate",
    "invoiceEmpty": "Nessuna email è stata ancora inviata per questa fattura.",
    "subject": "Oggetto",
    "type": "Tipo",
    "sentAt": "Inviata il",
    "types": {
      "Invoice": "Fattura",
      "Invite": "Invito",
      "ResetPassword": "Reimpostazione password"
    }
  },
  "updated": "Aggiornato"
}
